const colorMap = new Map([
    ['Rust', ["#b7410e", false]],
    ['Multicolor', ["https://i.ibb.co/BVjj74X/classic-color-spectrum-rgb-line-gradient-vector-522680-173-copy.png", true]],
    ['Peach', ["#ffdab9", false]],
    ['Golden', ["#ffd900", false]],
    ['Off-White', ["#f5f5f5", false]],
    ['Cream', ["#fffdd0", false]],
    ['Sky Blue', ["#87CEEB", false]],
    ['Navy Blue', ["#000080", false]],
    ['Light Blue', ["#ADD8E6", false]],
    ['Olive Green', ["#556B2F", false]],
    ['Light Green', ["#90EE90", false]],
    ['Dark Grey', ["#A9A9A9", false]],
    ['Dark Blue', ["#00008B", false]],
    ['Jet Black', ["#000000", false]],
    ['Bright White', ["#FFFFFF", false]],
    ['Light Grey', ["#D3D3D3", false]],
    ['Wine', ["#722F37", false]],
    ['Teal Blue', ["#008080", false]],
    ['Royal Blue', ["#4169E1", false]],
    ['Indigo Blue', ["#4B0082", false]],
    ['Mid Blue', ["#0000CD", false]],
    ['Peacock Blue', ["#006994", false]],
    ['Deep Blue', ["#000080", false]],
    ['Aqua Blue', ["#00FFFF", false]],
    ['Ice Blue', ["#BCE6E6", false]],
    ['Night Blue', ["#191970", false]],
    ['Denim Blue', ["#1560BD", false]],
    ['Turquoise Blue', ["#40E0D0", false]],
    ['Brick Red', ["#B22222", false]],
    ['Light Red', ["#FF6961", false]],
    ['Dark Red', ["#8B0000", false]],
    ['Bright Red', ["#FF0000", false]],
    ['Carrot red', ["#FF4500", false]],
    ['Burn Red', ["#9A3334", false]],
    ['Cardinal Red', ["#C41E3A", false]],
    ['Oxblood Red', ["#800020", false]],
    ['Rio Red', ["#DA2C43", false]],
    ['Rose Red', ["#FF033E", false]],
    ['Rumba Red', ["#C76E70", false]],
    ['Spice Red', ["#A23C3C", false]],
    ['Tango Red', ["#E25822", false]],
    ['Deep Red', ["#8B0000", false]],
    ['Mustard Yellow', ["#FFDB58", false]],
    ['Light Yellow', ["#FFFFE0", false]],
    ['Lemon Yellow', ["#FFF44F", false]],
    ['Mellow Yellow', ["#F8DE7E", false]],
    ['Bright Yellow', ["#FFFF00", false]],
    ['Golden Yellow', ["#FFD700", false]],
    // ['Honey Yellow', ["#E0Cfalse", false]],
    ['Chrome Yellow', ["#FFA700", false]],
    ['Corn Yellow', ["#FBEC5D", false]],
    ['Musturd Yellow', ["#FFDB58", false]],
    ['Pale Yellow', ["#EEE8AA", false]],
    ['Pastel Yellow', ["#FDFD96", false]],
    ['Taffy Yellow', ["#F8DE7E", false]],
    ['Dark Green', ["#006400", false]],
    ['Light Pink', ["#FFB6C1", false]],
    ['Onion Pink', ["#F5B9F5", false]],
    ['Island Pink', ["#FFD1DC", false]],
    ['Lilac Pink', ["#FFC0CB", false]],
    ['Rose Pink', ["#FF66CC", false]],
    ['Coral Pink', ["#FF7F50", false]],
    ['Dusty Pink', ["#D8BFD8", false]],
    ['Send Pink', ["#FF91A4", false]],
    ['Blossom Pink', ["#FFC3A0", false]],
    ['Delicacy Pink', ["#FEC3AC", false]],
    ['Flamingo Pink', ["#FC8EAC", false]],
    ['Pastel Pink', ["#FFD1BB", false]],
    ['Baby Pink', ["#FFC0CB", false]],
    ['Pastel Purple', ["#B39EB5", false]],
    ['Dark Purple', ["#800080", false]],
    ['Beige', ["#F5F5DC", false]],
    ['Light Purple', ["#E6E6FA", false]],
    ['Cloud Cream', ["#FFF8E7", false]],
    ['Custard Cream', ["#FFF0C1", false]],
    ['Dark Cream', ["#EEE8AA", false]],
    ['Dawn Cream', ["#FFFAF0", false]],
    ['Fawn Cream', ["#E5AA70", false]],
    ['Italian Cream', ["#F6ECD8", false]],
    ['Light Orange', ["#FFD68F", false]],
    ['Apricot Orange', ["#FDD5B1", false]],
    ['Bright Orange', ["#FF8C00", false]],
    ['Burnt Orange', ["#FF4500", false]],
    ['Coral Orange', ["#FF7F50", false]],
    ['Golden Orange', ["#FFD700", false]],
    ['Apricot Orange', ["#FBCEB1", false]],
    ['Dark Olive', ["#556B2F", false]],
    ['Olive Brown', ["#806517", false]],
    ['Light Olive', ["#AAB300", false]],
    ['Olive Grey', ["#B5B35C", false]],
    ['Branch Olive', ["#5F6527", false]],
    ['Dark Olive Green', ["#556B2F", false]],
    ['Deep Olive Green', ["#556B2F", false]],
    ['Dusty Olive', ["#8A8662", false]],
    ['Olive Melange', ["#6B6C4A", false]],
    ['Dark Maroon', ["#800000", false]],
    ['Maroon gold', ["#B03060", false]],
    ['Silver Grey', ["#C0C0C0", false]],
    ['Lime Green', ["#00FF00", false]],
    ['State Gray', ["#808080", false]],
    ['Teal Green', ["#008080", false]],
    ['Dusty Teal', ["#4e5d4e", false]],
    ['Teal Black', ["#003838", false]],
    ['Teal Grey', ["#69838d", false]],
    ['Midnight Navy', ["#000080", false]],
    ['Grey Melange', ["#808080", false]],
    ['Charcoal Grey', ["#36454F", false]],
    ['Ercus Melange', ["#B5B5B5", false]],
    ['Air Force Blue', ["#5D8AA8", false]],
    ['Aquamarine Blue', ["#7FFFD4", false]],
    ['Carrot Brown', ["#ED9121", false]],
    ['Colonial Blue', ["#002F6C", false]],
    ['Cornet Blue', ["#6495ED", false]],
    ['Deep Wine', ["#8B0000", false]],
    ['Bottle Green', ["#092E20", false]],
]);

const defaultSortCollectionHandles = [
    "all", "formals", "casuals"
];

const newArrivalCollectionHandles = [
    "new-arrivals-lounge-wear","formal-shirt-new-arrivals","formal-trouser-new-arrivals","party-wear-shirt-new-arrivals","modi-jacket-new-arrivals","modi-kurta-new-arrivals","club-wear-trouser-new-arrivals","casual-shirt-new-arrivals","casual-trouser-new-arrivals","polo-t-shirt-new-arrivals","semi-casual-shirt-new-arrivals","t-shirt-new-arrivals","jeans-new-arrivals","blazers-new-arrivals","waistcoats-bandhgala-jackets-new-arrivals"
];

const normalCollectionHandles = [
    "modi-kurta-jacket","modi-kurta","modi-jacket","top-wear-casual","t-shirts","oversized-t-shirts","polo-t-shirts","casual-shirts","semi-casual-shirts","bottom-wear","jeans","trousers-chinos","baggy-denims","cargo","winter-wear","winter-t-shirts","winter-jackets","top-wear-formals","office-wear-shirts","evening-party-wear-shirts","formal-bottom-wear","trousers","club-wear-trousers","formals-jackets","modi-jacket","waistcoats-bandhgala-jackets","blazers","loungewear","track-pants","joggers","shorts","boxer-shorts","capri","athleisure"
];

const brandCategoryWiseCollectionHandles = [
    "azania-aligadhi","virasana-bandhgala-jacket","jb-studio-blazer","greenfibre-blazer","jadeblue-blazer","wyre-blazer","jadeblue-cargo-pant","greenfibre-cargo-pant","jadeblue-casual-shirt","greenfibre-casual-shirt","jb-studio-casual-shirt","jadeblue-casual-trouser","greenfibre-casual-trouser","jb-studio-club-wear-trouser","greenfibre-club-wear-trouser","wyre-club-wear-trouser","greenfibre-formal-shirt","metal-formal-shirt","jadeblue-formal-shirt","jadeblue-youth-formal-shirt","jadeblue-super-luxe-formal-shirt","jadeblue-formal-trouser","greenfibre-formal-trouser","jb-studio-formal-trouser","metal-formal-trouser","jadeblue-youth-formal-trouser","wyre-formal-trouser","jadeblue-super-luxe-formal-trouser","azania-indowestern","tula-indowestern","jadeblue-indowestern","virasana-indowestern","jadeblue-jeans","greenfibre-jeans","the-kurta-company-kurta","greenfibre-kurta","tula-kurta-pajama","jadeblue-kurta-pajama","azania-kurta-pajama","tula-kurta-pajama-with-koti","azania-kurta-pajama-with-koti","virasana-kurta-pajama-with-koti","jadeblue-modi-jacket","jadeblue-modi-kurta","greenfibre-party-wear-shirt","jb-studio-party-wear-shirt","wyre-party-wear-shirt","jadeblue-super-luxe-party-wear-shirt","jadeblue-polo-t-shirt","greenfibre-polo-t-shirt","jade-play-polo-t-shirt","jadeblue-semi-casual-shirt","azania-semi-indowestern","tula-sherwani","azania-sherwani","tula-sleeveless-bandhgala","azania-sleeveless-bandhgala","greenfibre-t-shirt","jadeblue-t-shirt","jb-studio-waistcoat","greenfibre-waistcoat","wyre-waistcoat","jadeblue-winter-jacket","greenfibre-winter-jacket","jadeblue-winter-t-shirt","greenfibre-winter-t-shirt"
]

const ethnicCollectionHandles = [
    "ethnic-wear","wedding-wear","jodhpuri","indowestern","suits-tuxedos","festive-wear","kurtas","kurta-pajama","kurta-pajama-with-koti","sleeveless-bandhgala","the-kurta-company","bestsellers-at-flat-40-off","luxe-ethnic-the-kurta-company","the-kurta-company-jacquard-kurtas","printed-kurtas-for-men","the-kurta-company-plain-kurtas","sherwani","churidar-aligarhi"
];

const removeNewArrivalSortCollectionHandles = [
    "upto-40","modi-kurta-up-to-40-off","modi-jacket-up-to-40-off","casuals-up-to-40-entire-collections","t-shirt-up-to-40-off","polo-t-shirt-up-to-40-off","casual-shirt-up-to-40-off","semi-casual-shirt-up-to-40-off","jeans-up-to-40-off","casual-trouser-up-to-40-off","formals-up-to-40-entire-collections","formal-shirt-up-to-40-off","party-wear-shirt-up-to-40-off","formal-trouser-up-to-40-off","club-wear-trouser-up-to-40-off","up-to-40-off-lounge-wear","track-pant-up-to-40-off","joggers-up-to-40-off","shorts-up-to-40-off","boxer-short-up-to-40-off","capri-up-to-40-off","up-to-50-entire-collections","modi-kurta-up-to-50-off","modi-jacket-up-to-50-off","t-shirt-up-to-50-off","polo-t-shirt-up-to-50-off","casual-shirts-up-to-50-off","semi-casual-shirts-up-to-50-off","jeans-up-to-50-off","casual-trouser-chinos-up-to-50-off","formal-office-wear-shirts-up-to-50-off","evening-party-wear-shirts-up-to-50-off","formal-trousers-up-to-50-off","club-wear-trousers-up-to-50-off","up-to-50-off-lounge-wear","flat-40-above-entire-collections","modi-kurta-flat-40-off-above","modi-jacket-flat-40-off-above","t-shirts-flat-40-off","polo-t-shirts-flat-40-off","casual-shirts-flat-40-off","semi-casual-shirts-flat-40-off","denims-flat-40-off","casual-trousers-flat-40-off","office-wear-shirts-flat-50-off","evening-wear-shirts-flat-40-off","formal-trousers-flat-40-off-above","club-wear-trouser-flat-40-off-above","lounge-wear-flat-40-off-above","4-way-stretch-40-50","flat-50-entire-collection","modi-kurta-flat-50-off","modi-jacket-flat-50-off","t-shirt-_-50","polo-t-shirt-_-50","casual-shirts-_-50","semi-casual-shirts-_-50","jeans-_-50","casual-trousers-_-50","office-wear-shirts-_-50","evening-wear-shirts-_-50","formal-trousers-flat-50-off","club-wear-trouser-flat-50-off","lounge-wear-flat-50"
];

const removeDiscountSortCollectionHandles = [
    "ethnic-wear","wedding-wear","jodhpuri","indowestern","suits-tuxedos","festive-wear","kurtas","kurta-pajama","kurta-pajama-with-koti","sleeveless-bandhgala","churidar-aligarhi","the-kurta-company","bestsellers-at-flat-40-off","luxe-ethnic-the-kurta-company","the-kurta-company-jacquard-kurtas","printed-kurtas-for-men","the-kurta-company-plain-kurtas","sherwani","all","modi-kurta-jacket","modi-kurta","modi-jacket","casuals","top-wear-casual","t-shirts","oversized-t-shirts","polo-t-shirts","casual-shirts","semi-casual-shirts","bottom-wear","jeans","trousers-chinos","baggy-denims","cargo","winter-wear","winter-t-shirts","winter-jackets","formals","top-wear-formals","office-wear-shirts","evening-party-wear-shirts","formal-bottom-wear","trousers","club-wear-trousers","formals-jackets","modi-jacket","waistcoats-bandhgala-jackets","blazers","loungewear","track-pants","joggers","shorts","boxer-shorts","capri","athleisure","new-arrivals-entire-collections","casuals-new-arrivals-entire-collections","formals-new-arrivals-entire-collections","new-arrivals-lounge-wear","formal-shirt-new-arrivals","formal-trouser-new-arrivals","party-wear-shirt-new-arrivals","modi-jacket-new-arrivals","modi-kurta-new-arrivals","club-wear-trouser-new-arrivals","casual-shirt-new-arrivals","casual-trouser-new-arrivals","polo-t-shirt-new-arrivals","semi-casual-shirt-new-arrivals","t-shirt-new-arrivals","jeans-new-arrivals","blazers-new-arrivals","waistcoats-bandhgala-jackets-new-arrivals"
];

/**
 * newly added code - starts here
 */
const newArrivalSortCollectionHandles = [
    "new-arrivals-entire-collections","casuals-new-arrivals-entire-collections","formals-new-arrivals-entire-collections","new-arrivals-lounge-wear","formal-shirt-new-arrivals","formal-trouser-new-arrivals","party-wear-shirt-new-arrivals","modi-jacket-new-arrivals","modi-kurta-new-arrivals","club-wear-trouser-new-arrivals","casual-shirt-new-arrivals","casual-trouser-new-arrivals","polo-t-shirt-new-arrivals","semi-casual-shirt-new-arrivals","t-shirt-new-arrivals","jeans-new-arrivals","blazers-new-arrivals","waistcoats-bandhgala-jackets-new-arrivals"
];

const normalCollectionHandles1 =  [
    "all","modi-kurta-jacket","modi-kurta","modi-jacket","casuals","top-wear-casual","t-shirts","oversized-t-shirts","polo-t-shirts","casual-shirts","semi-casual-shirts","bottom-wear","jeans","trousers-chinos","baggy-denims","cargo","winter-wear","winter-t-shirts","winter-jackets","formals","top-wear-formals","office-wear-shirts","evening-party-wear-shirts","formal-bottom-wear","trousers","club-wear-trousers","formals-jackets","modi-jacket","waistcoats-bandhgala-jackets","blazers","loungewear","track-pants","joggers","shorts","boxer-shorts","capri","athleisure"
];

const brandCategoryWiseCollectionHandles1 = [
    "azania-aligadhi","virasana-bandhgala-jacket","jb-studio-blazer","greenfibre-blazer","jadeblue-blazer","wyre-blazer","jadeblue-cargo-pant","greenfibre-cargo-pant","jadeblue-casual-shirt","greenfibre-casual-shirt","jb-studio-casual-shirt","jadeblue-casual-trouser","greenfibre-casual-trouser","jb-studio-club-wear-trouser","greenfibre-club-wear-trouser","wyre-club-wear-trouser","greenfibre-formal-shirt","metal-formal-shirt","jadeblue-formal-shirt","jadeblue-youth-formal-shirt","jadeblue-super-luxe-formal-shirt","jadeblue-formal-trouser","greenfibre-formal-trouser","jb-studio-formal-trouser","metal-formal-trouser","jadeblue-youth-formal-trouser","wyre-formal-trouser","jadeblue-super-luxe-formal-trouser","azania-indowestern","tula-indowestern","jadeblue-indowestern","virasana-indowestern","jadeblue-jeans","greenfibre-jeans","the-kurta-company-kurta","greenfibre-kurta","tula-kurta-pajama","jadeblue-kurta-pajama","azania-kurta-pajama","tula-kurta-pajama-with-koti","azania-kurta-pajama-with-koti","virasana-kurta-pajama-with-koti","jadeblue-modi-jacket","jadeblue-modi-kurta","greenfibre-party-wear-shirt","jb-studio-party-wear-shirt","wyre-party-wear-shirt","jadeblue-super-luxe-party-wear-shirt","jadeblue-polo-t-shirt","greenfibre-polo-t-shirt","jade-play-polo-t-shirt","jadeblue-semi-casual-shirt","azania-semi-indowestern","tula-sherwani","azania-sherwani","tula-sleeveless-bandhgala","azania-sleeveless-bandhgala","greenfibre-t-shirt","jadeblue-t-shirt","jb-studio-waistcoat","greenfibre-waistcoat","wyre-waistcoat","jadeblue-winter-jacket","greenfibre-winter-jacket","jadeblue-winter-t-shirt","greenfibre-winter-t-shirt"
];

const ethnicCollectionHandles1 = [
    "ethnic-wear","wedding-wear","jodhpuri","indowestern","suits-tuxedos","festive-wear","kurtas","kurta-pajama","kurta-pajama-with-koti","sleeveless-bandhgala","the-kurta-company","bestsellers-at-flat-40-off","luxe-ethnic-the-kurta-company","the-kurta-company-jacquard-kurtas","printed-kurtas-for-men","the-kurta-company-plain-kurtas","sherwani","churidar-aligarhi"
];

const lowestDiscountSort = [
    "all","modi-kurta-jacket","modi-kurta","modi-jacket","casuals","top-wear-casual","t-shirts","oversized-t-shirts","polo-t-shirts","casual-shirts","semi-casual-shirts","bottom-wear","jeans","trousers-chinos","baggy-denims","cargo","winter-wear","winter-t-shirts","winter-jackets","formals","top-wear-formals","office-wear-shirts","evening-party-wear-shirts","formal-bottom-wear","trousers","club-wear-trousers","formals-jackets","modi-jacket","waistcoats-bandhgala-jackets","blazers","loungewear","track-pants","joggers","shorts","boxer-shorts","capri","athleisure","azania-aligadhi","virasana-bandhgala-jacket","jb-studio-blazer","greenfibre-blazer","jadeblue-blazer","wyre-blazer","jadeblue-cargo-pant","greenfibre-cargo-pant","jadeblue-casual-shirt","greenfibre-casual-shirt","jb-studio-casual-shirt","jadeblue-casual-trouser","greenfibre-casual-trouser","jb-studio-club-wear-trouser","greenfibre-club-wear-trouser","wyre-club-wear-trouser","greenfibre-formal-shirt","metal-formal-shirt","jadeblue-formal-shirt","jadeblue-youth-formal-shirt","jadeblue-super-luxe-formal-shirt","jadeblue-formal-trouser","greenfibre-formal-trouser","jb-studio-formal-trouser","metal-formal-trouser","jadeblue-youth-formal-trouser","wyre-formal-trouser","jadeblue-super-luxe-formal-trouser","azania-indowestern","tula-indowestern","jadeblue-indowestern","virasana-indowestern","jadeblue-jeans","greenfibre-jeans","the-kurta-company-kurta","greenfibre-kurta","tula-kurta-pajama","jadeblue-kurta-pajama","azania-kurta-pajama","tula-kurta-pajama-with-koti","azania-kurta-pajama-with-koti","virasana-kurta-pajama-with-koti","jadeblue-modi-jacket","jadeblue-modi-kurta","greenfibre-party-wear-shirt","jb-studio-party-wear-shirt","wyre-party-wear-shirt","jadeblue-super-luxe-party-wear-shirt","jadeblue-polo-t-shirt","greenfibre-polo-t-shirt","jade-play-polo-t-shirt","jadeblue-semi-casual-shirt","azania-semi-indowestern","tula-sherwani","azania-sherwani","tula-sleeveless-bandhgala","azania-sleeveless-bandhgala","greenfibre-t-shirt","jadeblue-t-shirt","jb-studio-waistcoat","greenfibre-waistcoat","wyre-waistcoat","jadeblue-winter-jacket","greenfibre-winter-jacket","jadeblue-winter-t-shirt","greenfibre-winter-t-shirt","ethnic-wear","wedding-wear","jodhpuri","indowestern","suits-tuxedos","festive-wear","kurtas","kurta-pajama","kurta-pajama-with-koti","sleeveless-bandhgala","the-kurta-company","bestsellers-at-flat-40-off","luxe-ethnic-the-kurta-company","the-kurta-company-jacquard-kurtas","printed-kurtas-for-men","the-kurta-company-plain-kurtas","sherwani","churidar-aligarhi"
]



function applicableForCustomKSADiscountSortUpdated(collectionHandle) {
    if(
        newArrivalSortCollectionHandles.includes(collectionHandle) || 
        normalCollectionHandles1.includes(collectionHandle) ||
        brandCategoryWiseCollectionHandles1.includes(collectionHandle) ||
        ethnicCollectionHandles1.includes(collectionHandle)) {
        return true;
    }
    return false;
}
/**
 * newly added code - ends here
 */


function applicableForCustomKSASort(collectionHandle) {
    if(
        newArrivalCollectionHandles.includes(collectionHandle) || 
        normalCollectionHandles.includes(collectionHandle) ||
        brandCategoryWiseCollectionHandles.includes(collectionHandle) ||
        ethnicCollectionHandles.includes(collectionHandle)) {
        return true;
    }
    return false;
}

function isOnCollectionPage() {
    if (window.location.pathname.includes("collection") && !window.location.pathname.includes("products")) {
        return true;
    }
    return false;
}


/**
 * Converts a product URL into Shopify's collection-aware product URL
 * (/collections/{collection-handle}/products/{product-handle}) when the
 * shopper is browsing a collection page. Other pages keep the original URL.
 */
function getCollectionAwareProductUrl(url) {
    if (!url || typeof url !== "string") return url;

    const productPathIndex = url.indexOf("/products/");
    if (productPathIndex === -1) return url;

    let collectionHandle = "";
    if (window?.wizzyConfig?.common?.isOnCategoryPage && window.wizzyConfig.common.collectionHandle) {
        collectionHandle = window.wizzyConfig.common.collectionHandle;
    } else if (isOnCollectionPage()) {
        const match = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
        collectionHandle = match ? decodeURIComponent(match[1]) : "";
    }
    if (!collectionHandle) return url;

    const root = window?.Shopify?.routes?.root || "/";
    return `${root}collections/${encodeURIComponent(collectionHandle)}${url.slice(productPathIndex)}`;
}
window.getCollectionAwareProductUrl = getCollectionAwareProductUrl;

/**
 * Formats a Wizzy price ("1,299.00", "1299.5" or 1299) as a whole number
 * with thousands separators ("1,299"). Prices are rounded to the nearest rupee.
 */
const WIZZY_PRICE_FIELDS = ["price", "discount", "finalPrice", "sellingPrice"];

function formatPriceWithoutDecimals(value) {
    if (value === undefined || value === null || value === "") return value;

    const amount = Math.round(parseFloat(String(value).replace(/,/g, "")));
    if (isNaN(amount)) return value;

    return typeof amount.formatMoney === "function"
        ? amount.formatMoney(0)
        : amount.toLocaleString("en-US");
}

function removePriceDecimals(product) {
    WIZZY_PRICE_FIELDS.forEach((field) => {
        if (product[field] === undefined || product[field] === null) return;
        product[field] = Array.isArray(product[field])
            ? product[field].map(formatPriceWithoutDecimals)
            : formatPriceWithoutDecimals(product[field]);
    });
    return product;
}


window.onWizzyScriptLoaded = function () {
    window.replaceWizzyTemplate("wizzy-search-results");
    window.replaceWizzyTemplate("wizzy-search-results-product");
    window.replaceWizzyTemplate("wizzy-search-summary");
    if (window.innerWidth < 768) {
     window.replaceWizzyTemplate("wizzy-search-wrapper");
    } else{
     let newDiv = document.getElementById("wizzy-search-wrapper-desktop");
     let oldDiv = document.getElementById("wizzy-search-wrapper");
     newDiv = newDiv.text;
     oldDiv.text = newDiv;
    }

    // var isFirstLoad = true;
    // window.wizzyConfig.events.registerEvent(
    // window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED, 
    // function (payload) {
    //     console.log("Before filters executed", payload);
    //     if(isOnCollectionPage() && payload.filters.page == 1)
    //     {
    //         removeRelevance(payload.filters);
    //     }
    //     if((isFirstLoad && isOnCollectionPage() && (payload.filters.sort[0]?.field === "relevance" || payload.filters.sort[0]?.field === "createdAt" ))){
    //         if(window.wizzyConfig.common.isOnCategoryPage===true && applicableForCustomKSASort(window.wizzyConfig.common.collectionHandle)) {
    //             payload.filters.sort = [ 
    //                 {field: 'relevance', order: 'asc'}, 
    //                 {field: `product_${window.wizzyConfig.common.collectionHandle}_ksa:float`, order: 'desc'}, 
    //                 { field: 'sellingPrice', order: 'desc' },  
    //                 {field: 'product_wizzy-best-selling_sortOrder:float', order: 'asc'} 
    //             ];
    //         } else if(window.wizzyConfig.common.isOnCategoryPage===true && defaultSortCollectionHandles.includes(window.wizzyConfig.common.collectionHandle)) {
    //             payload.filters.sort = [ 
    //                 {field: 'relevance', order: 'asc'}, 
    //                 {field: 'product_ksa:float', order: 'desc'}, 
    //                 { field: 'product_new_arrivals_date_custom:datetime', order: 'asc' },  
    //                 {field: 'product_wizzy-best-selling_sortOrder:float', order: 'asc'} 
    //             ];
    //         } else if(window.wizzyConfig.common.isOnCategoryPage===true && newArrivalSortCollectionHandles.includes(window.wizzyConfig.common.collectionHandle)) {
    //             payload.filters.sort = [ 
    //                 {field: 'relevance', order: 'asc'}, 
    //                 {field: `product_${window.wizzyConfig.common.collectionHandle}_ksa:float`, order: 'desc'}, 
    //                 { field: 'product_new_arrivals_date_custom:datetime', order: 'asc' }
    //             ];
    //         } 
    //         if(window.wizzyConfig.common.isOnCategoryPage===true && lowestDiscountSort.includes(window.wizzyConfig.common.collectionHandle)) {
    //             payload.filters.sort = [ 
    //                 {field: 'relevance', order: 'asc'}, 
    //                 {field: `product_${window.wizzyConfig.common.collectionHandle}_ksa:float`, order: 'desc'}, 
    //                 { field: 'discountPercentage', order: 'asc' }
    //             ];
    //         }
    //     }

    //     // if(window.wizzyConfig.common.isOnCategoryPage===true && applicableForCustomKSASort(window.wizzyConfig.common.collectionHandle)) {
    //     //     customKSASort(payload.filters, window.wizzyConfig.common.collectionHandle);
    //     // }
    //     // else if(window.wizzyConfig.common.isOnCategoryPage===true && defaultSortCollectionHandles.includes(window.wizzyConfig.common.collectionHandle)) {
    //     //     defaultSort(payload.filters);
    //     // }
    //     // else if(window.wizzyConfig.common.isOnCategoryPage===true && newArrivalSortCollectionHandles.includes(window.wizzyConfig.common.collectionHandle)) {
    //     //     newArrivalsSort(payload.filters, window.wizzyConfig.common.collectionHandle);
    //     // } 
    //     // else if(window.wizzyConfig.common.isOnCategoryPage===true && lowestDiscountSort.includes(window.wizzyConfig.common.collectionHandle)) {
    //     //     lowestDisountSort(payload.filters, window.wizzyConfig.common.collectionHandle);
    //     // }


    //     if(isOnCollectionPage() && payload.filters.sort[0]?.field !== "relevance") {
    //         payload.filters.sort.unshift({field: 'relevance', order: 'asc'});

    //         payload.filters.sort = payload.filters.sort.map(sort => {
    //             if (sort.field === "product_new_arrivals_date_custom") {
    //                 return {
    //                     ...sort,
    //                     field: "product_new_arrivals_date_custom:datetime"
    //                 };
    //             }
    //             return sort;
    //         });
    //     }
    //     return payload;
    // },3);

    var isFirstLoad = true;
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED, 
    function (payload) {
        console.log("BEFORE_FILTERS_EXECUTED", payload);
        if(isOnCollectionPage() && payload.filters.sort[0]?.field !== "relevance") {
            payload.filters.sort.unshift({field: 'relevance', order: 'asc'});
            payload.filters.inStock = ["true"];
        }
        return payload;
    }, 3);

    const removeRelevance = (filter) => {
        let isJson = false;
        let isSortJson = false;
        if (typeof filter == "string") {
            isJson = true;
            filter = JSON.parse(filter);
        }
        if (typeof filter.sort == "string") {
            isSortJson = true;
            filter.sort = JSON.parse(filter.sort);
        }
        let newSort = [];
        //when sort is relevance than update sort as per requierment
        // if (filter.sort[0].field === "relevance") {
        //   newSort.push(
        //     // {
        //     //   field: "discountPercentage",
        //     //   order: "desc",
        //     // },
        //     {
        //       field: "product_wizzy-best-selling_sortOrder:float",
        //       order: "asc",
        //     },
        //   );
            
        // } else {
        //   //else make sure that selected sort is applying
        //   newSort = filter.sort;
        // }
        filter.sort.forEach((x) => {
            if (
                x.field != "relevance" && 
                x.field != "createdAt"
            ) {
                newSort.push(x);
            }
            });
        filter.sort = newSort;
        if (isSortJson) {
            filter.sort = JSON.stringify(filter.sort);
        }
        if (isJson) {
            filter = JSON.stringify(filter);
        }
    };

    const lowestDisountSort = (filter, handle) => {
        let isJson = false;
        let isSortJson = false;
        if (typeof filter == "string") {
            isJson = true;
            filter = JSON.parse(filter);
        }
        if (typeof filter.sort == "string") {
            isSortJson = true;
            filter.sort = JSON.parse(filter.sort);
        }
        let newSort = [];
        //when sort is relevance than update sort as per requierment
        // if (filter.sort[0].field === "relevance") {
        newSort.push(
            {
                field: "relevance",
                order: "asc",
            },
            {
                field: `product_${handle}_ksa:float`,
                order: "desc",
            },
            { field: 'discountPercentage', order: 'asc' }
        );
            
        // } else {
        //   //else make sure that selected sort is applying
        //   newSort = filter.sort;
        // }
        filter.sort.forEach((x) => {
            if (
                x.field != "relevance" && 
                x.field != `product_${handle}_ksa:float` &&
                x.field != "discountPercentage"
            ) {
                newSort.push(x);
            }
            });
        filter.sort = newSort;
        if (isSortJson) {
            filter.sort = JSON.stringify(filter.sort);
        }
        if (isJson) {
            filter = JSON.stringify(filter);
        }
    };

    const newArrivalsSort = (filter, handle) => {
        let isJson = false;
        let isSortJson = false;
        if (typeof filter == "string") {
            isJson = true;
            filter = JSON.parse(filter);
        }
        if (typeof filter.sort == "string") {
            isSortJson = true;
            filter.sort = JSON.parse(filter.sort);
        }
        let newSort = [];
        //when sort is relevance than update sort as per requierment
        // if (filter.sort[0].field === "relevance") {
        newSort.push(
            {
                field: "relevance",
                order: "asc",
            },
            {
                field: `product_${handle}_ksa:float`,
                order: "desc",
            },
            { field: 'product_new_arrivals_date_custom:datetime', order: 'asc' }
        );
            
        // } else {
        //   //else make sure that selected sort is applying
        //   newSort = filter.sort;
        // }
        filter.sort.forEach((x) => {
            if (
                x.field != "relevance" && 
                x.field != `product_${handle}_ksa:float` &&
                x.field != "product_new_arrivals_date_custom:datetime"
            ) {
                newSort.push(x);
            }
            });
        filter.sort = newSort;
        if (isSortJson) {
            filter.sort = JSON.stringify(filter.sort);
        }
        if (isJson) {
            filter = JSON.stringify(filter);
        }
    };

    const defaultSort = (filter) => {
        let isJson = false;
        let isSortJson = false;
        if (typeof filter == "string") {
            isJson = true;
            filter = JSON.parse(filter);
        }
        if (typeof filter.sort == "string") {
            isSortJson = true;
            filter.sort = JSON.parse(filter.sort);
        }
        let newSort = [];
        //when sort is relevance than update sort as per requierment
        // if (filter.sort[0].field === "relevance") {
        newSort.push(
            {
                field: "relevance",
                order: "asc",
            },
            {
                field: `product_ksa:float`,
                order: "desc",
            },
            { field: 'product_new_arrivals_date_custom:datetime', order: 'desc' }, 
            {field: 'product_wizzy-best-selling_sortOrder:float', order: 'asc'}
        );
            
        // } else {
        //   //else make sure that selected sort is applying
        //   newSort = filter.sort;
        // }
        filter.sort.forEach((x) => {
            if (
                x.field != "relevance" && 
                x.field != `product_ksa:float` &&
                x.field != "product_new_arrivals_date_custom:datetime" &&
                x.field != "product_wizzy-best-selling_sortOrder:float"
            ) {
                newSort.push(x);
            }
            });
        filter.sort = newSort;
        if (isSortJson) {
            filter.sort = JSON.stringify(filter.sort);
        }
        if (isJson) {
            filter = JSON.stringify(filter);
        }
    };

    const customKSASort = (filter, handle) => {
        let isJson = false;
        let isSortJson = false;
        if (typeof filter == "string") {
            isJson = true;
            filter = JSON.parse(filter);
        }
        if (typeof filter.sort == "string") {
            isSortJson = true;
            filter.sort = JSON.parse(filter.sort);
        }
        let newSort = [];
        //when sort is relevance than update sort as per requierment
        // if (filter.sort[0].field === "relevance") {
        newSort.push(
            {
                field: "relevance",
                order: "asc",
            },
            {
                field: `product_${handle}_ksa:float`,
                order: "desc",
            },
            { field: 'sellingPrice', order: 'desc' }, 
            {field: 'product_wizzy-best-selling_sortOrder:float', order: 'asc'}
        );
            
        // } else {
        //   //else make sure that selected sort is applying
        //   newSort = filter.sort;
        // }
        filter.sort.forEach((x) => {
            if (
                x.field != "relevance" && 
                x.field != `product_${handle}_ksa:float` &&
                x.field != "sellingPrice" &&
                x.field != "product_wizzy-best-selling_sortOrder:float"
            ) {
                newSort.push(x);
            }
            });
        filter.sort = newSort;
        if (isSortJson) {
            filter.sort = JSON.stringify(filter.sort);
        }
        if (isJson) {
            filter = JSON.stringify(filter);
        }
    };

    if (window.innerWidth > 768) {
        window.replaceWizzyTemplate("wizzy-autocomplete-topproducts");

    } else {
        window.wizzyConfig.search.configs.facets.leftFacets.defaultCollapsed = true;
        window.wizzyConfig.search.configs.facets.leftFacets.firstLeftDefaultOpened = true;
        let newDiv = document.getElementById('wizzy-autocomplete-topproducts-mobile' + "-new");
        let oldDiv = document.getElementById('wizzy-autocomplete-topproducts');
        newDiv = newDiv.text;
        oldDiv.text = newDiv;
        var closeButton = document.getElementById('closeButton');
        if(closeButton) {

            closeButton.addEventListener('click', function () {
                var wizzyIcon = document.querySelector('.wizzy-icon');
                var inputBox = document.querySelector('#wizzy-search-input');
                if (wizzyIcon) {
                    wizzyIcon.click();
                    inputBox.click();
                }
                var wizzySearchIcon = document.querySelector('.wizzy-search-form');
                wizzySearchIcon.style.display = 'block';
            });
        }
        var closeButton = document.getElementById('wizzyDisplayControl');
        if(closeButton) {
        closeButton.addEventListener('click', function () {
            var wizzySearchIcon = document.querySelector('.wizzy-search-form');
            wizzySearchIcon.style.display = 'none';
        });
    }
    }

    function preloadImage(url) {
        var img = new Image();
        img.src = url;
    }

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_INIT, 
        function (payload) {
            window.wizzyConfig.search.configs.facets.showPriceInputRangeFields = true;
            window.wizzyConfig.search.configs.facets.leftFacets.defaultCollapsed = true;
            window.wizzyConfig.search.configs.facets.leftFacets.firstLeftDefaultOpened = true;
            window.wizzyConfig.search.configs.pagination.type = "pagination";
            // window.wizzyConfig.search.configs.general.searchEndpoint = "/search";
            payload.filters = {
                configs: {
                    keepOpenedInMobileAfterApply: true,
                    displayAsDrawer: true,
                    drawerPosition: 'left'
                }
            }
            
            // if(!window.wizzyConfig.common.isOnCategoryPage)
            // {
            //     console.log("wiz inside init content");
            //     window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            //         "#MainContent.wizzy-main-content"
            //     ]
            // }
            window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
                ".search__input.field__input"
            ]
            window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
                desktop: 2500,
                mobile: 2500,
            };
            payload.search.configs.facets.leftFacets.defaultCollapsed = true;
            payload.search.configs.facets.leftFacets.firstLeftDefaultOpened = false;
            payload.search.configs.facets.leftFacets.mobileCollapsible = true;

            payload.search.tileView.display = true;
            payload.common.lazyDOMConfig.searchInputIdentifiers.push({
                dom: "#wizzySearch", 
                type: "search",
            });

            window.wizzyConfig.search.configs.pagination.appendInExistingList = 'true';
            
            // if (isOnCollectionPage() && removeNewArrivalSortCollectionHandles.includes(window.wizzyConfig.common.collectionHandle)) {
            //     window.wizzyConfig.search.configs.sorts.configs = window.wizzyConfig.search.configs.sorts.configs.filter(
            //         item => item.field !== "product_new_arrivals_date_custom"
            //     );
            // } else if (isOnCollectionPage() && removeDiscountSortCollectionHandles.includes(window.wizzyConfig.common.collectionHandle)) {
            //     window.wizzyConfig.search.configs.sorts.configs = window.wizzyConfig.search.configs.sorts.configs.filter(
            //         item => item.label !== "Lowest Discount" && item.label !== "Highest Discount"
            //         );
            // }
            // window.wizzyConfig.filters.configs.layout = "v2";
            // window.wizzyConfig.search.configs.facets.filtersButtonMobile.position = "top";
            return payload;
        },3
    );

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
        function (payload) {
            let allFacets = payload.response.payload.facets;
            allFacets.forEach((obj) => {
                if (obj.label == "Discount") {
                    let disArray = obj.data;
                    const sortedObj = disArray.sort((a, b) => {
                        const aLabel = a.label.toUpperCase();
                        const bLabel = b.label.toUpperCase();

                        if (aLabel.charAt(0) === 'N' && bLabel.charAt(0) !== 'N') {
                            return -1;
                        } else if (aLabel.charAt(0) !== 'N' && bLabel.charAt(0) === 'N') {
                            return 1;
                        }

                        if (aLabel.charAt(1) === 'U' && bLabel.charAt(1) !== 'U') {
                            return -1;
                        } else if (aLabel.charAt(1) !== 'U' && bLabel.charAt(1) === 'U') {
                            return 1; 
                        }
                        return aLabel.localeCompare(bLabel);
                    });
                }
            })
            // if (window.wizzyConfig.common.isOnCategoryPage === true) {
            //     var newSortConfig = {
            //         "label": "Popular",
            //         "field": "product_ksa:float",
            //         "order": "desc"
            //     };
            //     var sortsConfigs = window.wizzyConfig?.search?.configs?.sorts?.configs;
            //     if (sortsConfigs) {
            //         var fieldExists = sortsConfigs.some(config => config.field === newSortConfig.field);
            //         if (!fieldExists) {
            //             sortsConfigs.push(newSortConfig);
            //         }
            //     }
            // }
            return payload;
        }
    );

    function handleResize() {
        var element = document.getElementById('wizzySearch');
        var width = element.getBoundingClientRect().width;
        var autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');
        document.documentElement.style.setProperty('--custom-width', width + 'px');
    }
    var wizzySearchElement = document.getElementById('wizzySearch');
    wizzySearchElement.addEventListener('input', function () {
        handleResize();
    });
    window.addEventListener('resize', handleResize);

    if (window.innerWidth > 768) {
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutationRecord) {
                if (mutationRecord != undefined && mutationRecord.target.classList && mutationRecord.target.classList.contains("invisible")) {
                    document.body.classList.remove("wizzy-scrollbar-fix");
                } else {
                    document.body.classList.add("wizzy-scrollbar-fix");
                    var wizzyIcon = document.querySelector('#wizzySearch');
                    if (wizzyIcon) {
                        wizzyIcon.click();
                    }
                }
            });
        });
        var target = document.getElementById('wizzyId');
        observer.observe(target, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
    
    function getAvailableCollectionCategories() {
        try {
            const selector = '.wizzy-filters-facet-block.facet-block-product_category_filter_magento .wizzy-facet-body .wizzy-facet-list li';

            const items = document.querySelectorAll(selector);

            if (!items || !items.length) {
                console.log('No Product Category filters found.');
                return [];
            }

            const categories = [];

            items.forEach(item => {
                const title = item.getAttribute('title');

                if (title && title.trim()) {
                    categories.push(title.trim());
                }
            });

            console.log('Available Categories:', categories);

            return categories;
        } catch (error) {
            console.error('Error while fetching collection categories:', error);
            return [];
        }
    }
    let allowedCategories = [];
    let allowedCategoriesKurtas = [];

    // const kurtaSubCategories = [
    //     {
    //         label: "KURTAS",
    //         values: ["Kurtas"]
    //     },
    //     {
    //         label: "KURTA PAJAMA",
    //         values: ["Kurta Pajama"]
    //     },
    //     {
    //         label: "KOTI KURTA",
    //         values: [
    //             "Kurta Pajama with Koti",
    //             "Koti Kurta"
    //         ]
    //     }
    // ];
    // Kurta Collection
    allowedCategoriesKurtas = [
        {
            label: "KURTAS",
            values: ["Kurtas"]
        },
        {
            label: "KURTA PAJAMA",
            values: ["Kurta Pajama"]
        },
        {
            label: "KOTI KURTA",
            values: ["Kurta Pajama with Koti", "Koti Kurta"]
        }
    ];

    // All Other Collections
    allowedCategories = [

        // 1. Modi Jacket
        {
            label: "MODI JACKET",
            values: ["Modi Jacket", "Modi Jackets"]
        },

        // 2. Linen Lineage
        {
            label: "LINEN LINEAGE",
            values: ["Linen Lineage"]
        },

        // 3. Top Wear
        {
            label: "ALL TOP WEAR",
            values: ["All Top Wear", "All Top wears"]
        },
        {
            label: "SHIRTS",
            values: ["Semi Casual Shirts","Shirts", "Casual Shirts","Formal Shirts","Office Wear Shirts","Party Wear Shirts"]
        },
        {
            label: "T-SHIRTS",
            values: ["T-Shirts", "T-shirts"]
        },
        {
            label: "POLO T-SHIRTS",
            values: ["Polos", "Polo T-Shirts", "Polo T-shirts"]
        },

        // 4. Bottom Wear
        {
            label: "ALL BOTTOM WEAR",
            values: ["All Bottom Wear"]
        },
        // {
        //     label: "DENIMS",
        //     values: ["Denims", "Jeans", "baggy denims"]
        // },
        // {
        //     label: "TROUSERS",
        //     values: ["Formal Trousers", "Casual Trousers", "Trousers"]
        // },
        {
            label: "DENIMS",
            values: ["Denims", "Jeans", "Baggy Denims"]
        },
        {
            label: "TROUSERS",
            values: ["Formal Trousers", "Casual Trousers", "Club Wear Trousers", "Trousers"]
        },

        // 5. Blazers
        {
            label: "BLAZERS",
            values: ["Blazer", "Blazers"]
        },

        // 6. Ethnic Wear
        {
            label: "ALL ETHNIC WEAR",
            values: ["All Ethnic Wear"]
        },
        {
            label: "KURTA",
            values: ["Kurta", "Kurtas"]
        },
        {
            label: "JODHPURI",
            values: [
                "Jodhpuri / Bandhgala",
                "Jodhpuri",
                // "Sleeveless Bandhgala",
                // "Waistcoats & Bandhgala Jackets"
            ]
        },
        {
            label: "INDO WESTERN",
            values: [
                "Indo-Western",
                "Indo Western",
                "Indowestern",
                "Semi Indowestern"
            ]
        },
        {
            label: "WAISTCOAT",
            values: [
                "Waist coats",
                "Waist Coats",
                "Waistcoats & Bandhgala Jackets",
                // "Sleeveless Bandhgala"
            ]
        },
        {
            label: "Bandhgala",
            values: [
               "Sleeveless Bandhgala"
            ]
        },

    ];

    function normalizeText(text) {
        return String(text || "")
            .toLowerCase()
            .replace(/&/g, "and")
            .replace(/-/g, " ")
            .replace(/\s+/g, " ")
            .trim();
    }

    function getSelectedCategoryFilters() {
        return Array.from(document.querySelectorAll(
            '.wizzy-filters-facet-block.facet-block-product_category_filter_magento .wizzy-facet-body .wizzy-facet-list li.active, \
            .wizzy-filters-facet-block.facet-block-product_category_filter_magento .wizzy-facet-body .wizzy-facet-list li.selected'
        ));
    }

    function getMatchedCategories(collectionCategories, categoryMap) {

        if (!Array.isArray(collectionCategories) || !Array.isArray(categoryMap)) {
            return [];
        }

        return categoryMap
            .map(category => {

                const matchedValue = category.values.find(value => {
                    return collectionCategories.some(collectionCategory =>
                        normalizeText(collectionCategory) === normalizeText(value)
                    );
                });

                return matchedValue
                    ? {
                        ...category,
                        matchedValue
                    }
                    : null;

            })
            .filter(Boolean);
    }

    function buildKurtaSubTabs(container)
    {
        if (!container) {
            return;
        }

        allowedCategoriesKurtas.forEach(category =>
        {
            const button = document.createElement("button");

            button.type = "button";
            button.className = "wizzy-kurta-sub-tab";

            button.textContent = category.label;

            // Store the actual Wizzy category that should be clicked
            button.dataset.categoryFilter = category.values[0];

            container.appendChild(button);
        });
    }

    function buildCategoryTabs(matchedCategories)
    {
        if (!Array.isArray(matchedCategories)) {
            return;
        }

        // Remove old tabs
        document.querySelector(".wizzy-custom-category-tabs")?.remove();
        document.querySelector(".wizzy-kurta-sub-tabs")?.remove();

        // Don't show tabs if there is only one category
        if (matchedCategories.length <= 1) {
            return;
        }

        const filterContainer = document.querySelector(
            ".wizzy-search-results-container"
        );

        if (!filterContainer) {
            console.warn("Wizzy filter container not found.");
            return;
        }

        const tabsWrapper = document.createElement("div");
        tabsWrapper.className = "wizzy-custom-category-tabs";

        const kurtaSubTabsContainer = document.createElement("div");
        kurtaSubTabsContainer.className = "wizzy-kurta-sub-tabs";
        kurtaSubTabsContainer.style.display = "none";

        // ALL
        const allButton = document.createElement("button");
        allButton.type = "button";
        allButton.className = "wizzy-custom-category-tab active";
        allButton.textContent = "ALL";
        allButton.dataset.clearCategoryFilter = "true";
        allButton.dataset.categoryFilter = "ALL";

        tabsWrapper.appendChild(allButton);

        matchedCategories.forEach(category =>
        {
            const button = document.createElement("button");

            button.type = "button";
            button.className = "wizzy-custom-category-tab";
            button.textContent = category.label;
            button.dataset.categoryFilter = category.matchedValue;

            tabsWrapper.appendChild(button);

            if (category.label === "KURTA") {
                buildKurtaSubTabs(kurtaSubTabsContainer);
            }
        });

        filterContainer.prepend(tabsWrapper);

        if (kurtaSubTabsContainer.childElementCount) {
            tabsWrapper.insertAdjacentElement(
                "afterend",
                kurtaSubTabsContainer
            );
        }
    }

    function initializeCustomCategoryTabs()
    {
        const tabsWrapper = document.querySelector(".wizzy-custom-category-tabs");

        if (!tabsWrapper) {
            return;
        }

        const kurtaSubTabsContainer = document.querySelector(".wizzy-kurta-sub-tabs");

        function applyCategoryFilter(category, tabLabel)
        {
            // Clear existing category filters
            getSelectedCategoryFilters().forEach(filter => filter.click());

            if (!category || category === "ALL") {
                return;
            }

            const filters = document.querySelectorAll(
                '.wizzy-filters-facet-block.facet-block-product_category_filter_magento .wizzy-facet-body .wizzy-facet-list li'
            );

            let categoriesToApply = [category];

            if (["SHIRTS", "TROUSERS", "DENIMS"].includes(tabLabel)) {
                const multiCategory = allowedCategories.find(
                    item => item.label === tabLabel
                );

                if (multiCategory) {
                    categoriesToApply = multiCategory.values.filter(value =>
                        Array.from(filters).some(filter =>
                            normalizeText(filter.getAttribute("title")) === normalizeText(value)
                        )
                    );
                }
            }

            categoriesToApply.forEach(categoryValue =>
            {
                const matchedFilter = Array.from(filters).find(filter =>
                {
                    const title = filter.getAttribute("title");

                    return (
                        title &&
                        normalizeText(title) === normalizeText(categoryValue)
                    );
                });

                matchedFilter?.click();
            });
        }

        // -----------------------------
        // Parent Category Tabs
        // -----------------------------
        tabsWrapper.addEventListener("click", function (event)
        {
            const button = event.target.closest(".wizzy-custom-category-tab");

            if (!button) {
                return;
            }

            const label = button.textContent.trim();

            document
                .querySelectorAll(".wizzy-custom-category-tab")
                .forEach(tab => tab.classList.remove("active"));

            button.classList.add("active");

            // -----------------------------
            // ALL
            // -----------------------------
            if (button.dataset.clearCategoryFilter)
            {
                if (kurtaSubTabsContainer)
                {
                    kurtaSubTabsContainer.style.display = "none";
                }

                document
                    .querySelectorAll(".wizzy-kurta-sub-tab")
                    .forEach(tab => tab.classList.remove("active"));

                applyCategoryFilter("ALL");
                return;
            }

            // -----------------------------
            // KURTA Parent
            // -----------------------------
            if (label === "KURTA")
            {
                if (kurtaSubTabsContainer)
                {
                    kurtaSubTabsContainer.style.display = "flex";

                    const firstSubTab = kurtaSubTabsContainer.querySelector(
                        ".wizzy-kurta-sub-tab"
                    );

                    if (firstSubTab)
                    {
                        firstSubTab.click();
                    }
                }

                return;
            }

            // Hide Kurta sub tabs
            if (kurtaSubTabsContainer)
            {
                kurtaSubTabsContainer.style.display = "none";
            }

            document
                .querySelectorAll(".wizzy-kurta-sub-tab")
                .forEach(tab => tab.classList.remove("active"));

            applyCategoryFilter(button.dataset.categoryFilter, label);
        });

        // -----------------------------
        // Kurta Sub Tabs
        // -----------------------------
        if (kurtaSubTabsContainer)
        {
            kurtaSubTabsContainer.addEventListener("click", function (event)
            {
                const button = event.target.closest(".wizzy-kurta-sub-tab");

                if (!button) {
                    return;
                }

                document
                    .querySelectorAll(".wizzy-kurta-sub-tab")
                    .forEach(tab => tab.classList.remove("active"));

                button.classList.add("active");

                // Keep parent active
                document
                    .querySelectorAll(".wizzy-custom-category-tab")
                    .forEach(tab =>
                    {
                        if (tab.textContent.trim() === "KURTA")
                        {
                            tab.classList.add("active");
                        }
                    });

                applyCategoryFilter(button.dataset.categoryFilter);
            });
        }
    }

    function syncActiveCategoryTab()
    {
        const selectedCategory = document.querySelector(
            '.facet-block-product_category_filter_magento li.active, \
            .facet-block-product_category_filter_magento li.selected'
        );

        const parentTabs = document.querySelectorAll(".wizzy-custom-category-tab");
        const subTabs = document.querySelectorAll(".wizzy-kurta-sub-tab");
        const subContainer = document.querySelector(".wizzy-kurta-sub-tabs");

        const isKurtaCollection =
            window?.wizzyConfig?.common?.collectionHandle === "kurtas";

        parentTabs.forEach(tab => tab.classList.remove("active"));
        subTabs.forEach(tab => tab.classList.remove("active"));

        if (!selectedCategory)
        {
            document
                .querySelector('.wizzy-custom-category-tab[data-category-filter="ALL"]')
                ?.classList.add("active");

            if (subContainer)
            {
                subContainer.style.display = "none";
            }

            return;
        }

        const selectedTitle = selectedCategory.getAttribute("title");

        const kurtaCategory = allowedCategoriesKurtas.find(category =>
            category.values.some(value =>
                normalizeText(value) === normalizeText(selectedTitle)
            )
        );

        // -----------------------------
        // Kurta Categories
        // -----------------------------
        if (kurtaCategory)
        {
            if (isKurtaCollection)
            {
                // Dedicated Kurta collection
                parentTabs.forEach(tab =>
                {
                    if (
                        normalizeText(tab.textContent) ===
                        normalizeText(kurtaCategory.label)
                    )
                    {
                        tab.classList.add("active");
                    }
                });
            }
            else
            {
                // Normal collection
                parentTabs.forEach(tab =>
                {
                    if (tab.textContent.trim() === "KURTA")
                    {
                        tab.classList.add("active");
                    }
                });

                if (subContainer)
                {
                    subContainer.style.display = "flex";
                }

                subTabs.forEach(tab =>
                {
                    if (
                        normalizeText(tab.textContent) ===
                        normalizeText(kurtaCategory.label)
                    )
                    {
                        tab.classList.add("active");
                    }
                });
            }

            return;
        }

        // -----------------------------
        // Hide Kurta sub tabs
        // -----------------------------
        if (subContainer)
        {
            subContainer.style.display = "none";
        }

        // -----------------------------
        // Normal parent sync
        // -----------------------------
        parentTabs.forEach(tab =>
        {
            if (
                normalizeText(tab.dataset.categoryFilter) ===
                normalizeText(selectedTitle)
            )
            {
                tab.classList.add("active");
                return;
            }

            if (tab.textContent.trim() === "SHIRTS") {
                const shirtsCategory = allowedCategories.find(item => item.label === "SHIRTS");

                if (
                    shirtsCategory?.values.some(value =>
                        normalizeText(value) === normalizeText(selectedTitle)
                    )
                )
                {
                    tab.classList.add("active");
                }
            }
        });
    }

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
        function (data)
        {

            let apply_button = document.querySelector('.wizzy-apply-all-button-block');
            if(apply_button)
            {
                apply_button.addEventListener('click', function(){
                    let wz_close_button = document.querySelector('.wizzy-filters-close-btn');
                    if(wz_close_button)
                    {
                        wz_close_button.click();
                    }
                })
            }
            if(window?.wizzyConfig?.common?.isOnCategoryPage)
            {
                document.body.classList.add('wizzy-collection');
                document.body.classList.remove('wizzy-search');
            }
            else
            {
                document.body.classList.add('wizzy-search');
                document.body.classList.remove('wizzy-collection');
            }
            const collectionCategories = getAvailableCollectionCategories();

            const categoryMap =
                window?.wizzyConfig?.common?.collectionHandle === "kurtas"
                    ? allowedCategoriesKurtas
                    : allowedCategories;

            const matchedCategories = getMatchedCategories(
                collectionCategories,
                categoryMap
            );

            buildCategoryTabs(matchedCategories);

            if (document.querySelector(".wizzy-custom-category-tabs"))
            {
                initializeCustomCategoryTabs();
                syncActiveCategoryTab();
            }

            document.addEventListener("click", function (e) {
                const dotsItem = e.target.closest(".dots-item");

                if (!dotsItem) return;

                // Hide the +3 button
                dotsItem.style.setProperty("display", "none", "important");

                // Show all hidden color items in the same color list
                const colorList = dotsItem.closest(".color-list");

                colorList.querySelectorAll(".color-item.hidden").forEach(item => {
                    item.classList.remove("hidden");
                    item.style.display = "block"; // or "inline-block"/"flex" depending on your CSS
                });
            });

            if(window?.wizzyConfig?.common?.isOnCategoryPage)
            {
               if(data?.data?.response?.payload?.total)
               {
                    let count = data.data.response.payload.total;
                    let count_ele = document.querySelector('.wizzy-total-filter-product');
                    if(count_ele)
                    {
                        console.log("inside count element");
                        count_ele.textContent = `${count} products`;
                    }
               }
            }

            return data;
        }
    );

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
        function (data)
        {
            let apply_button = document.querySelector('.wizzy-apply-all-button-block');
            if(apply_button)
            {
                apply_button.addEventListener('click', function(){
                    let wz_close_button = document.querySelector('.wizzy-filters-close-btn');
                    if(wz_close_button)
                    {
                        wz_close_button.click();
                    }
                })
            }
            if(window?.wizzyConfig?.common?.isOnCategoryPage)
            {
                document.body.classList.add('wizzy-collection');
                document.body.classList.remove('wizzy-search');
            }
            else
            {
                document.body.classList.add('wizzy-search');
                document.body.classList.remove('wizzy-collection');
            }
            const collectionCategories = getAvailableCollectionCategories();

            const categoryMap =
                window?.wizzyConfig?.common?.collectionHandle === "kurtas"
                    ? allowedCategoriesKurtas
                    : allowedCategories;

            const matchedCategories = getMatchedCategories(
                collectionCategories,
                categoryMap
            );

            buildCategoryTabs(matchedCategories);

            if (document.querySelector(".wizzy-custom-category-tabs"))
            {
                initializeCustomCategoryTabs();
                syncActiveCategoryTab();
            }

            document.addEventListener("click", function (e) {
                const dotsItem = e.target.closest(".dots-item");

                if (!dotsItem) return;

                // Hide the +3 button
                dotsItem.style.setProperty("display", "none", "important");

                // Show all hidden color items in the same color list
                const colorList = dotsItem.closest(".color-list");

                colorList.querySelectorAll(".color-item.hidden").forEach(item => {
                    item.classList.remove("hidden");
                    item.style.display = "block"; // or "inline-block"/"flex" depending on your CSS
                });
            });

            return data;
        }
    );
    // const removeSortCollections = ['flat-50-entire-collection'];
    // window.wizzyConfig.events.registerEvent(
    //     window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    //     function (payload) {
    //         if(window.wizzyConfig.common.isOnCategoryPage && removeSortCollections.includes(window.wizzyConfig.common.collectionHandle))
    //         {
    //             document.body.classList.add('wz-remove-sort');
    //         }
    //         else
    //         {
    //             document.body.classList.remove('wz-remove-sort');
    //         }
    //         const swiper = new Swiper(".swiper-container", {
                
    //             loop: true,

    //             pagination: {
    //                 el: ".swiper-pagination",
    //                 clickable: true,
    //                 type: "bullets",
    //             },
    //             navigation: {
    //                 nextEl: ".swiper-button-next",
    //                 prevEl: ".swiper-button-prev"
    //             },
    //             autoHeight: true,
    //             spaceBetween: "30",
                
    //         });

    //         const x = document.querySelector(".swiper").swiper;

    //         //code for adding product count
    //         if(window.wizzyConfig.common.isOnCategoryPage) {
    //             const productCountEle = document.querySelector(".wizzy-total-filter-product");
    //             var productCount = payload?.data?.response?.payload?.total;
    //             if(productCountEle) {
    //                 productCountEle.textContent = productCount + ' Products';
    //             }
    //         }

    //         const listItemElements = document.querySelectorAll('li.wizzy-selected-facet-list-item');
    //         const facetKeySet = new Set();

    //         listItemElements.forEach((liElement) => {
    //             const facetKey = liElement.getAttribute('data-facetkey');
    //             facetKeySet.add(facetKey);
    //         });

    //         const uniqueFacetKeyCount = facetKeySet.size;
    //         const linkElement = document.querySelector('a.wizzy-filters-mobile-entry');
    //         linkElement.innerText = "Filters " + '(' + uniqueFacetKeyCount + ')';


    //         document.addEventListener('click', function (e) {
    //             const icon = e.target.closest('.wizzy-tile-icon-grid');
                
    //             if (!icon) {console.log("icon");return};
    //             const level = icon.getAttribute('data-tile-level');
    //             if (!level) {console.log("level");return};
                
    //             const wrapper = document.querySelector('.wizzy-search-wrapper');
    //             if (!wrapper) {console.log("wrapper");return};
                
    //             wrapper.setAttribute('wizzy-tile-view-level', level);
    //             // toggle active class
    //             const allIcons = icon.closest('.wizzy-tile-button').querySelectorAll('.wizzy-tile-icon-grid');
    //             allIcons.forEach(el => el.classList.remove('active'));
    //             icon.classList.add('active');
    //         });


    //         let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //         const targetDiv = document.querySelector('.wizzy-search-filters-top');
            
    //         window.addEventListener('scroll', function () {
    //             const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    //             if (targetDiv && currentScroll < lastScrollTop) {
    //                 targetDiv.classList.add('scroll-up');
    //             } else {
    //                 targetDiv.classList.remove('scroll-up');
    //             }
    //             lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    //         });


    //         return payload;
    //     }
    // ); by wizzy

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
        function (payload) {
            let wz_autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');

            if (wz_autocomplete) {
                console.log("inside remove autocomplete");
                wz_autocomplete.style.setProperty('display', 'none', 'important');
            }
            let banner = document.querySelector('.banner__content');
            if(banner)
            {
                banner.style.display = "none";
            }
            let banner_media = document.querySelector('.banner');
            if(banner)
            {
                banner_media.style.display = "none";
            }
            document.body.classList.remove('header-transparent');
            document.body.classList.remove('template-index');
            var wizzyIcon = document.querySelector('.wizzy-search-back');

            if (wizzyIcon) {
                wizzyIcon.click();
            }

            var wizzySearchIcon = document.querySelector('.wizzy-search-form');
            wizzySearchIcon.style.display = 'none';

            var colProd = document.querySelector('.featured-category-wrapper.text-body.bg-page');
            if (colProd) {
                colProd.style.display = 'none';
            }
            var wizzyDisplay = document.querySelector('#wizzyDisplay');
            if (wizzyDisplay) {
                wizzyDisplay.style.display = 'none';
            }

            const wizzyElement = document.getElementById('wizzyId');


            wizzyElement.classList.add('invisible');
            wizzyElement.classList.add('h-0');
            wizzyElement.classList.add('opacity-0');

            return payload;
        }
    );

    const targetNode = document.querySelector(".wizzy-body-end-wrapper");
    function updateBodyClass() {
        const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
        autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
        if(autocompleteElement)
        {
            // const heads = document.querySelectorAll('.autocomplete-item-head');
            handleResize();
        }
        // if(autocompleteElement)
        // {   
        //     autocompleteElement.addEventListener('click', function(){
        //         let close_button = document.querySelector('.search-modal__close-button');
        //         if(close_button)
        //         {
        //             close_button.click();
        //         }
        //         autocompleteElement.style.display = "none";
        //     })
        // }
    }

    const search_modal = document.querySelector('.search-modal__content');

    if (search_modal) {
        search_modal.addEventListener('click', function (e) {
            const ignore = e.composedPath().some(el =>
                el instanceof Element &&
                (
                    el.matches('.search__input.field__input') ||
                    el.matches('.search__button.field__button') ||
                    el.matches('.reset__button.field__button')
                )
            );

            if (ignore) return;

            e.stopPropagation();

            document.querySelector('.search-modal__close-button')?.click();
        });
    }

    const config = {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["style"]
    }
        , callback = function(mutationsList, observer2) {
        for (const mutation of mutationsList) {
            updateBodyClass();
            break
        }
    }
        , wizobserver = new MutationObserver(callback);
    targetNode && (wizobserver.observe(targetNode, config),
    updateBodyClass());

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function (payload) {
        window.wizzyConfig.pageStore.searchInputValue = payload.q;
        return payload;
    });

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS, function (payload) {
        var element = document.querySelector('[data-aid="collection-title"]');
        if (element && payload.response.payload.result) {
            var collectionTitle = element.textContent;
            setTimeout(function () {
                var element = document.querySelector('.wizzy-search-filters-list-top');
                element.textContent = "Home / ";
                var element = document.querySelector('.wizzy-search-filters-list-top');
                var spanElement = document.createElement('span');
                spanElement.textContent = collectionTitle;
                element.appendChild(spanElement);
                var spanElement = document.createElement('span');
                spanElement.setAttribute('id', 'wizzyProductCount');
                spanElement.textContent = " (" + payload.response.payload.total + " Products)";
                element.appendChild(spanElement);
                if (window?.baCurr) {
                    window?.baCurr?.refreshConversion();
                }
            }, 250);
        }

        let counts = document.querySelectorAll(".collection-breadcrumbs .collection-count");
        counts.forEach((item) => {
            item.innerText = `(${payload.response.payload.total})`;
        })
        if (payload.api === 'search' || payload.api === "filter") {
            var facets = payload.response.payload.facets;

            facets.forEach((facet) => {
                if (facet.key === "product_color_magento") {
                    const facetItem = facet.data;
                    facetItem.forEach((item) => {
                        let color = findHaxCode(item.key)
                        item.isSwatch = true;
                        item.isURLSwatch = color[1];
                        item.isVisualSwatch = true;
                        item.swatchValue = color[0];
                        item.data = {
                            value: item.key,
                            swatch: {
                                type: 'visual',
                                value: color[0]
                            }
                        }

                    })
                }
            })

        }
        return payload;
    });

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
        function (payload) {
            // Inject after paint so product cards exist in DOM
            setTimeout(function () {
                if (typeof window.injectWizzyColorSwatches === 'function') {
                    window.injectWizzyColorSwatches();
                }
            }, 50);

            return payload;
        });
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
        function (data) {
            let facets = data.response.payload.facets;
            for (let i = 0; i < facets.length; i++) {
                if (facets[i].key == "product_Size") {

                    let sizes = facets[i].data;
                    let numbers = [];
                    let letters = [];

                    for (let i = 0; i < sizes.length; i++) {
                        let individualSize = sizes[i].key.length;
                        if (sizes[i].key[individualSize - 1] >= '0' && sizes[i].key[individualSize - 1] <= '9') {
                            numbers.push(sizes[i]);
                        }
                    }
                    numbers.sort(function (a, b) {
                        if (a.key < b.key) {
                            return -1;
                        } else if (a.key > b.key) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });

                    let newArray = new Array();
                    let temp = ["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"];
                    for (let j = 0; j < temp.length; j++) {

                        for (let k = 0; k < sizes.length; k++) {
                            if (sizes[k].key == temp[j])
                                newArray.push(sizes[k]);
                        }
                    }

                    for (let index = 0; index < numbers.length; index++) {
                        newArray.push(numbers[index]);
                    }

                    facets[i].data = newArray;

                }
            }


            return data;

        });

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS, function (data) {
        let facets = data.response.payload.facets;
        for (let i = 0; i < facets.length; i++)
            if (facets[i].key == "sizes") {
                let sizes = facets[i].data
                    , numbers = []
                    , letters = []
                    , newArray = new Array
                    , temp = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "2XL", "3XL", "4XL", "5XL", "0", "1", "1.5", "2", "2.5", "3", "3.5", "4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12", "12.5", "13", "13.5", "14", "14.5", "15", "15.5", "16", "16.5", "17.5", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "50", "58", "61", "64", "66", "68", "69", "70", "71", "73", "74", "75", "76", "79", "80", "81", "84", "85", "90", "95", "100", "105", "110", "115", "120", "one-size"];
                for (let j = 0; j < temp.length; j++)
                    for (let k = 0; k < sizes.length; k++)
                        sizes[k].key == temp[j] && newArray.push(sizes[k]);
                facets[i].data = newArray
            }
        return data
    })

    const getWizzyProductHandle = (product, card) => {
        if (product?.handle) return product.handle;

        const handleAttr = product?.attributes?.find((attribute) =>
            attribute.id === "product_handle" || attribute.id === "handle"
        );
        if (handleAttr) {
            const first = handleAttr.values?.[0];
            if (typeof first === "string") return first;
            if (first?.value?.[0]) return first.value[0];
            if (Array.isArray(first?.value) && first.value[0]) return first.value[0];
        }

        const fromData = card?.getAttribute?.("data-product-handle");
        if (fromData) return fromData;

        const href = card?.querySelector?.('a[href*="/products/"]')?.getAttribute("href") || "";
        const match = href.match(/\/products\/([^\/?#]+)/);
        return match ? decodeURIComponent(match[1]) : "";
    };

    const getColorProductUrl = (color) => {
        let url = color.url || (color.handle ? `/products/${color.handle}` : "");
        if (!url && color.color) url = `/products/${color.color}`;
        return getCollectionAwareProductUrl(url);
    };

    const productColors = async (product, card) => {
        const productHandle = getWizzyProductHandle(product, card);
        if (!productHandle) return "";

        try {
            const res = await fetch(`/products/${productHandle}?view=colors`);
            if (!res.ok) return "";

            const responseText = (await res.text()).trim();
            // Theme may wrap JSON; try raw parse first, then extract array
            let colors;
            try {
                colors = JSON.parse(responseText);
            } catch (e) {
                const start = responseText.indexOf("[");
                const end = responseText.lastIndexOf("]");
                if (start === -1 || end === -1) return "";
                colors = JSON.parse(responseText.slice(start, end + 1));
            }

            if (!Array.isArray(colors) || !colors.length) return "";

            return colors.map((color, i) => {
                let dots = "";
                if (i === 2) {
                    const remaining = colors.length - 3;
                    if (remaining > 0) {
                        dots = `<a class="dots-item"><span class="ellipsis">+${remaining}</span></a>`;
                    }
                }
                const colorKey = String(color.color || "").toLowerCase().replace(/\s+/g, "-");
                const mainImage = color.images?.[0] || "";
                const hoverImage = color.images?.[1] || color.images?.[0] || "";
                const title = String(color.title || "").replace(/"/g, "&quot;");
                const colorUrl = getColorProductUrl(color);
                return `<a class="color-item${i > 2 ? " hidden" : i == 0 ? " active" : ""}" data-main-image="${mainImage}" data-hover-image="${hoverImage}" href="${colorUrl}" data-color="${colorKey}" data-title="${title}" title="${title}">
                  <span style="background-color: ${colorKey};background-image: url(${hoverImage});"></span>
              </a>${dots}`;
            }).join("");
        } catch (e) {
            console.warn("[wizzy colors]", e);
            return "";
        }
    };

    window.injectWizzyColorSwatches = async function () {
        const boxes = document.querySelectorAll(".wizzy-search-results-list .color-swatch-list, .color-swatch-list[data-wizzy-colors]");
        const products = window.__wizzyLastTransformedProducts || [];

        await Promise.all(Array.from(boxes).map(async (box) => {
            if (box.dataset.colorsLoaded === "true" || box.innerHTML.trim()) return;

            const card = box.closest(".wizzy-result-product, .wizzy-product-card, li.grid__item, [data-id]");
            const id = card?.getAttribute("data-id") || (card?.className || "").match(/wizzy-product-(\d+)/)?.[1];
            const product = products.find((p) => String(p.id) === String(id)) || {};
            const colorsHtml = product.colorsHtml || await productColors(product, card);
            if (!colorsHtml) return;

            const html = colorsHtml.includes("color-list")
                ? colorsHtml
                : `<div class="color-list flex">${colorsHtml}</div>`;

            box.innerHTML = html;
            box.dataset.colorsLoaded = "true";
        }));
    };

    const productSizes = async (product) => {
        let productHandle = product.attributes.find(attribute => attribute.id === "product_handle");

        if (!productHandle || !productHandle.values || !productHandle.values[0]) {
            return '';
        }

        productHandle = productHandle.values[0]['value'][0];


        try {
            let res = await fetch(`/products/${productHandle}?view=sizes`);

            if (!res.ok) {
                return '';
            }

            let responseText = await res.text();

            let sizes;
            try {
                sizes = JSON.parse(responseText);
            } catch (parseError) {
                return '';
            }

            if (!sizes || !Array.isArray(sizes) || sizes.length === 0) {
                // Try to handle different response formats
                if (sizes && typeof sizes === 'object') {
                    // If sizes is an object, it might contain variants
                    if (sizes.variants && Array.isArray(sizes.variants)) {
                        return sizes.variants.map((variant, i) => {
                            let sizeValue = variant.option1 || variant.title || `Size ${i + 1}`;
                            let isAvailable = variant.available;
                            let disabledClass = !isAvailable ? ' disabled' : '';
                            let disabledAttr = !isAvailable ? ' disabled' : '';
                            return `<a class="size-item${disabledClass}" data-main-image="${product.images[0]}" data-hover-image="${product.images[0]}" data-size="${sizeValue}" data-title="${product.title} - ${sizeValue}" data-variant-id="${variant.id}" data-available="${isAvailable}"${disabledAttr}>
                                  <span class="size-text">${sizeValue}</span>
                              </a>`;
                        }).join('');
                    }
                }

                return '';
            }

            return sizes?.map((size, i) => {
                let isAvailable = size.available;
                let disabledClass = !isAvailable ? ' disabled' : '';
                let disabledAttr = !isAvailable ? ' disabled' : '';
                let html = `<a class="size-item${disabledClass}" data-main-image="${product.images[0]}" data-hover-image="${product.images[0]}" data-size="${size.size}" data-title="${size.title}" data-variant-id="${size.variant_id}" data-available="${isAvailable}"${disabledAttr}>
                      <span class="size-text">${size.size}</span>
                  </a>`
                return html;
            }).join('');
        } catch (error) {
            // Fallback: try to create size swatches from product variants
            if (product.variants && product.variants.length > 0) {
                return product.variants.map((variant, i) => {
                    let sizeValue = variant.option1 || variant.title || `Size ${i + 1}`;
                    let isAvailable = variant.available;
                    let disabledClass = !isAvailable ? ' disabled' : '';
                    let disabledAttr = !isAvailable ? ' disabled' : '';
                    return `<a class="size-item${disabledClass}" data-main-image="${product.images[0]}" data-hover-image="${product.images[0]}" data-size="${sizeValue}" data-title="${product.title} - ${sizeValue}" data-variant-id="${variant.id}" data-available="${isAvailable}"${disabledAttr}>
                          <span class="size-text">${sizeValue}</span>
                      </a>`;
                }).join('');
            }

            // Final fallback: create some test sizes for debugging
            return `<a class="size-item" data-main-image="${product.images[0]}" data-hover-image="${product.images[0]}" data-size="S" data-title="${product.title} - S" data-variant-id="test-s" data-available="true">
                  <span class="size-text">S</span>
              </a>
              <a class="size-item" data-main-image="${product.images[0]}" data-hover-image="${product.images[0]}" data-size="M" data-title="${product.title} - M" data-variant-id="test-m" data-available="true">
                  <span class="size-text">M</span>
              </a>
              <a class="size-item" data-main-image="${product.images[0]}" data-hover-image="${product.images[0]}" data-size="L" data-title="${product.title} - L" data-variant-id="test-l" data-available="true">
                  <span class="size-text">L</span>
              </a>`;
        }
    }
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
        function (products) {
            products.forEach((product) => {
                // console.log("Product ==>", product);
                // let attributes = product.attributes;
                // console.log("product attributes", product.attributes);
                let attributes = product.attributes;
                if(attributes)
                {
                    // console.log("inside attributes");
                    attributes.forEach((attr) => {
                        if(attr.id === "product_tags")
                        {
                            const values = attr.values[0].value[0];
                            const tags = values.split(",").map(tag => tag.trim());

                            if (tags && tags.includes("New Arrivals")) {
                                product.new_arrival = true;
                            }
                        }
                        else if(attr.id === "product_handle")
                        {
                            product.handle = attr.values[0].value[0];
                        }
                        else if(attr.id == "product_wsl_count_Flits")
                        {
                            let wsl_count = attr.values[0].value[0];
                            if(wsl_count)
                            {
                                product.wsl_count = wsl_count;
                            }
                        }
                    })
                }

                // Keep the collection in the product URL when browsing a collection.
                product.url = getCollectionAwareProductUrl(product.url);

                // Show prices as whole numbers, without decimal points.
                removePriceDecimals(product);
            })

            return products;
    });

    // window.wizzyConfig.events.registerEvent(
    //     window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    //     function (data) {
    //         window.__wizzyLastTransformedProducts = data;

    //         data.forEach(async (product) => {
    //             // Ensure handle exists for template + color fetch
    //             product.handle = getWizzyProductHandle(product);

    //             product.mainImage = product.images[0];
    //             product.hoverImage = product.images.length > 1 ? product.images[1] : product.images[0];

    //             if (product.price) {
    //                 let varValue = product.price;
    //                 let ans = "";
    //                 for (let i = 0; i < varValue.length && varValue[i] !== '.'; i++) {
    //                     ans += varValue[i];
    //                 }
    //                 product.price = ans;
    //             }
    //             if (product.sellingPrice) {
    //                 let varValue = product.sellingPrice;
    //                 let ans = "";
    //                 for (let i = 0; i < varValue.length && varValue[i] !== '.'; i++) {
    //                     ans += varValue[i];
    //                 }
    //                 product.sellingPrice = ans;
    //             }

    //             let attributes = product.attributes;

    //             let newArrival = 0;
    //             attributes.forEach((attribute) => {
    //                 if (attribute.id == "product_badges_value_badges") {

    //                     newArrival = 1;

    //                 }

    //             });

    //             if (isOnCollectionPage()) {
    //                 // product.url = product.url + "?source=collection"
    //                 // product.url = window.location.href + "/" + product.url.replace(window.location.origin + '/', '');
    //                 let p_url = product.url.split('/products');
    //                 if (p_url.length >= 2) {
    //                     product.url = window.location.pathname + '/products' + p_url[1]
    //                 }
    //             }

    //             product.newArrival = newArrival;
    //             let colorsHtml = await productColors(product);
    //             if (colorsHtml) {
    //                 product.colorsHtml = `<div class="color-list flex">${colorsHtml}</div>`;
    //             }

    //             // Re-try inject once colors are ready (DOM may already be painted)
    //             if (typeof window.injectWizzyColorSwatches === "function") {
    //                 window.injectWizzyColorSwatches();
    //             }

    //             let sizesHtml = await productSizes(product);
    //             if (sizesHtml) {
    //                 product.sizesHtml = `<div class="size-list flex">${sizesHtml}</div>`;

    //                 // Populate size swatches immediately
    //                 let wizzyResultProduct = qs(`.wizzy-search-results-list .wizzy-group-product-${product.groupId}`);
    //                 if (wizzyResultProduct) {
    //                     // Find the existing size-swatch-list and populate it
    //                     let sizeContainer = qs('.size-swatch-list', wizzyResultProduct);
    //                     if (sizeContainer) {
    //                         sizeContainer.innerHTML = product.sizesHtml;

    //                         // Attach event listeners to size items immediately after creation
    //                         qsa('.size-item', sizeContainer)?.forEach(el => {
    //                             el.addEventListener('click', (e) => {
    //                                 e.preventDefault();
    //                                 let that = e.currentTarget;
    //                                 let parent = that.closest(".product-card");

    //                                 console.log('Size item clicked:', that.getAttribute('data-size'), 'Available:', that.getAttribute('data-available'));

    //                                 // Check if size is available or disabled
    //                                 if (that.getAttribute('data-available') === 'false' || that.classList.contains('disabled')) {
    //                                     console.log('Size not available, returning');
    //                                     return; // Don't proceed if size is not available or disabled
    //                                 }

    //                                 // Add loading state to the clicked size item
    //                                 that.classList.add('adding-to-cart');
    //                                 that.style.pointerEvents = 'none';

    //                                 parent.querySelectorAll(".size-item")?.forEach(innerEle => {
    //                                     innerEle.classList.remove('active');
    //                                 });
    //                                 that.classList.add("active");
    //                                 parent.querySelector('.product-card-product-heading').innerHTML = that.getAttribute('data-title');

    //                                 // Update product images
    //                                 let mainImage = that.getAttribute('data-main-image');
    //                                 let hoverImage = that.getAttribute('data-hover-image');
    //                                 let imageEle = parent.querySelector('.product-card-image .aspect-natural');
    //                                 if (imageEle) {
    //                                     let loader = imageEle.querySelector(".Image__Loader");
    //                                     if (loader) loader.classList.add("active");

    //                                     let mainImageTag = new Image();
    //                                     mainImageTag.onload = () => {
    //                                         let existingImg = imageEle.querySelector(".product-card-img");
    //                                         if (existingImg) existingImg.remove();
    //                                         imageEle.appendChild(mainImageTag);
    //                                         if (loader) loader.classList.remove("active");
    //                                     }
    //                                     mainImageTag.setAttribute("src", mainImage);
    //                                     mainImageTag.setAttribute("class", "relative product-card-img");

    //                                     let hoverImageTag = new Image();
    //                                     hoverImageTag.onload = () => {
    //                                         let existingHoverImg = imageEle.querySelector(".group-hover-image");
    //                                         if (existingHoverImg) existingHoverImg.remove();
    //                                         imageEle.appendChild(hoverImageTag);
    //                                         if (loader) loader.classList.remove("active");
    //                                     }
    //                                     hoverImageTag.setAttribute("src", hoverImage);
    //                                     hoverImageTag.setAttribute("class", "relative hidden group-hover:block group-hover-image");
    //                                 }

    //                                 // Add to cart functionality
    //                                 let variantId = that.getAttribute('data-variant-id');
    //                                 console.log('Adding to cart variant ID:', variantId);
    //                                 addToCart(variantId, 1).finally(() => {
    //                                     // Remove loading state after cart operation completes
    //                                     that.classList.remove('adding-to-cart');
    //                                     that.style.pointerEvents = '';
    //                                 });
    //                             });
    //                         });
    //                     }
    //                 }
    //             } else {
    //                 // No sizes found, don't show anything
    //                 product.sizesHtml = '';
    //             }
    //         });

    //         setTimeout(() => {

    //             const featuredList = document.querySelector(".collection-featured-list");
    //             const itemContainer = document.querySelector(".wizzy-collection-featured-list");
    //             const alreadyExistFeatureList = document.querySelector(".wizzy-collection-featured-list .collection-featured-list");
    //             if (featuredList && itemContainer && !alreadyExistFeatureList) {
    //                 // Clone the item template
    //                 const clonedItem = featuredList.cloneNode(true);
    //                 clonedItem.style.display = "block"; // Display the cloned item

    //                 // Append the cloned item to the container
    //                 itemContainer.insertBefore(clonedItem, itemContainer.firstChild);
    //             }

    //             // const breadcrumbs = document.querySelector(".collection-breadcrumbs");
    //             // const breadcrumbsContainer = document.querySelector(".search-filters-top-wrapper");
    //             // const alreadyExistBreadcrumbs = document.querySelector(".search-filters-top-wrapper .collection-breadcrumbs");
    //             // if (breadcrumbs && breadcrumbsContainer && !alreadyExistBreadcrumbs) {
    //             //     // Clone the item template
    //             //     const clonedBreadcrumbsItem = breadcrumbs.cloneNode(true);
    //             //     clonedBreadcrumbsItem.style.display = "block"; // Display the cloned item

    //             //     // Append the cloned item to the container
    //             //     breadcrumbsContainer.insertAdjacentElement("afterbegin", clonedBreadcrumbsItem);
    //             // }

    //             // if (window?.baCurr) {
    //             //     window?.baCurr?.refreshConversion();
    //             // } by wizzy
    //         }, 500)
    //         // setTimeout(() => { by wizzy
    //         //     data.length > 0 && data.forEach(product => {
    //         //         let wizzyResultProduct = qs(`.wizzy-search-results-list .wizzy-group-product-${product.groupId}`);

    //         //         if (product.colorsHtml && wizzyResultProduct) {
    //         //             qs('.color-swatch-list', wizzyResultProduct).innerHTML = product.colorsHtml;
    //         //         }

    //         //         // Fallback for size swatches if not already populated
    //         //         if (product.sizesHtml && wizzyResultProduct) {
    //         //             // Find the existing size-swatch-list and populate it if empty
    //         //             let sizeContainer = qs('.size-swatch-list', wizzyResultProduct);
    //         //             if (sizeContainer && sizeContainer.innerHTML.trim() === '') {
    //         //                 sizeContainer.innerHTML = product.sizesHtml;
    //         //             }
    //         //         }
    //         //     });
    //         //     // qsa('.color-item')?.forEach(el => {
    //         //     //     // console.log(el);
                    
    //         //     //     el.addEventListener('click', (e) => {
    //         //     //         e.preventDefault();
    //         //     //         let that = e.currentTarget;
    //         //     //         let parent = that.closest(".product-card");
    //         //     //         console.log(parent);

    //         //     //         parent.querySelectorAll(".color-item")?.forEach(innerEle => {
    //         //     //             innerEle.classList.remove('active');
    //         //     //         });
    //         //     //         that.classList.add("active");
    //         //     //         parent.querySelector('.product-card-product-heading').innerHTML = that.getAttribute('data-title');
    //         //     //         let mainImage = that.getAttribute('data-main-image');
    //         //     //         let hoverImage = that.getAttribute('data-hover-image');
    //         //     //         let imageEle = parent.querySelector('.product-card-image .aspect-natural');
    //         //     //         imageEle.querySelector(".Image__Loader").classList.add("active");
    //         //     //         let mainImageTag = new Image();
    //         //     //         console.log(mainImage,hoverImage);
    //         //     //         mainImageTag.onload = () => {
    //         //     //             imageEle.querySelector(".product-card-img").remove();
    //         //     //             imageEle.querySelector(".mainImage").appendChild(mainImageTag);
    //         //     //             imageEle.querySelector(".Image__Loader").classList.remove("active");
    //         //     //         }
    //         //     //         mainImageTag.setAttribute("src", mainImage);
    //         //     //         mainImageTag.setAttribute("class", "product-item-image blur-up img-fluid relative product-card-img lazyautosizes lazyloaded");

    //         //     //         let hoverImageTag = new Image();
    //         //     //         hoverImageTag.onload = () => {
    //         //     //             imageEle.querySelector('.hoverImage .group-hover-image').remove();
    //         //     //             imageEle.querySelector(".hoverImage").appendChild(hoverImageTag);
    //         //     //             imageEle.querySelector(".Image__Loader").classList.remove("active");
    //         //     //         }
    //         //     //         hoverImageTag.setAttribute("src", hoverImage);
    //         //     //         hoverImageTag.setAttribute("is", "responsive-image");
    //         //     //         hoverImageTag.setAttribute("class", "relative group-hover-image");
    //         //     //     });
    //         //     // });
    //         //     // qsa('.dots-item')?.forEach(el => {
    //         //     //     el.addEventListener('click', (e) => {
    //         //     //         let colorList = el.closest('.color-list');
    //         //     //         el.remove();
    //         //     //         qsa('.color-item.hidden', colorList)?.forEach(rmEl => {
    //         //     //             rmEl.classList.remove('hidden');
    //         //     //         })
    //         //     //     })
    //         //     // })

    //         //     // Size item event listeners are now attached immediately when size items are created
    //         // }, 500);

    //         // // Add event listeners for size swatch toggle functionality
    //         // qsa('.add-item-btn-js')?.forEach(el => {
    //         //     el.addEventListener('click', (e) => {
    //         //         e.preventDefault();
    //         //         let that = e.currentTarget;
    //         //         let productCard = that.closest('.product-card');

    //         //         console.log('Add item button clicked', productCard);

    //         //         if (productCard) {
    //         //             let sizeWrapper = qs('.size-swatch-wrapper', productCard);
    //         //             console.log('Size wrapper found:', sizeWrapper);
    //         //             if (sizeWrapper) {
    //         //                 // Remove active class from all other size wrappers
    //         //                 qsa('.size-swatch-wrapper.active')?.forEach(wrapper => {
    //         //                     wrapper.classList.remove('active');
    //         //                 });

    //         //                 // Add active class to current size wrapper
    //         //                 sizeWrapper.classList.add('active');
    //         //                 console.log('Size wrapper activated');

    //         //                 // Check if size items exist
    //         //                 let sizeItems = qsa('.size-item', sizeWrapper);
    //         //                 console.log('Size items found:', sizeItems.length);
    //         //             } else {
    //         //                 console.log('No size wrapper found in product card');
    //         //             }
    //         //         } else {
    //         //             console.log('No product card found');
    //         //         }
    //         //     });
    //         // });

    //         // // Add event listeners for size swatch close functionality
    //         // qsa('.size-swatch-close')?.forEach(el => {
    //         //     el.addEventListener('click', (e) => {
    //         //         e.preventDefault();
    //         //         let that = e.currentTarget;
    //         //         let sizeWrapper = that.closest('.size-swatch-wrapper');

    //         //         if (sizeWrapper) {
    //         //             sizeWrapper.classList.remove('active');
    //         //         }
    //         //     });
    //         // });

    //         // // Function to attach event listeners
    //         // function attachSizeSwatchListeners() {
    //         //     // Add event listeners for size swatch toggle functionality
    //         //     qsa('.add-item-btn-js')?.forEach(el => {
    //         //         // Check if listener already attached
    //         //         if (!el.hasAttribute('data-size-swatch-listener')) {
    //         //             el.setAttribute('data-size-swatch-listener', 'true');
    //         //             el.addEventListener('click', (e) => {
    //         //                 e.preventDefault();
    //         //                 let that = e.currentTarget;
    //         //                 let productCard = that.closest('.product-card');

    //         //                 if (productCard) {
    //         //                     let sizeWrapper = qs('.size-swatch-wrapper', productCard);
    //         //                     if (sizeWrapper) {
    //         //                         // Remove active class from all other size wrappers
    //         //                         qsa('.size-swatch-wrapper.active')?.forEach(wrapper => {
    //         //                             wrapper.classList.remove('active');
    //         //                         });

    //         //                         // Add active class to current size wrapper
    //         //                         sizeWrapper.classList.add('active');
    //         //                     }
    //         //                 }
    //         //             });
    //         //         }
    //         //     });

    //         //     // Add event listeners for size swatch close functionality
    //         //     qsa('.size-swatch-close')?.forEach(el => {
    //         //         // Check if listener already attached
    //         //         if (!el.hasAttribute('data-size-swatch-close-listener')) {
    //         //             el.setAttribute('data-size-swatch-close-listener', 'true');
    //         //             el.addEventListener('click', (e) => {
    //         //                 e.preventDefault();
    //         //                 let that = e.currentTarget;
    //         //                 let sizeWrapper = that.closest('.size-swatch-wrapper');

    //         //                 if (sizeWrapper) {
    //         //                     sizeWrapper.classList.remove('active');
    //         //                 }
    //         //             });
    //         //         }
    //         //     });
    //         // }

    //         // // Initial attachment
    //         // attachSizeSwatchListeners();

    //         // // Set up mutation observer to handle dynamically added elements
    //         // const observer = new MutationObserver((mutations) => {
    //         //     let shouldReattach = false;
    //         //     mutations.forEach((mutation) => {
    //         //         if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
    //         //             mutation.addedNodes.forEach((node) => {
    //         //                 if (node.nodeType === 1) { // Element node
    //         //                     if (node.classList?.contains('add-item-btn-js') ||
    //         //                         node.classList?.contains('size-swatch-close') ||
    //         //                         node.querySelector?.('.add-item-btn-js') ||
    //         //                         node.querySelector?.('.size-swatch-close')) {
    //         //                         shouldReattach = true;
    //         //                     }
    //         //                 }
    //         //             });
    //         //         }
    //         //     });

    //         //     if (shouldReattach) {
    //         //         setTimeout(attachSizeSwatchListeners, 100);
    //         //     }
    //         // });

    //         // // Start observing
    //         // observer.observe(document.body, {
    //         //     childList: true,
    //         //     subtree: true
    //         // });

    //         window.__wizzyLastTransformedProducts = data;
    //         return data;
    //     }
    // );

    // window.wizzyConfig.events.registerEvent(
    //     window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    //     function (data) {
    //         setTimeout(() => {
    //             qsa('.color-item')?.forEach(el => {
    //                 // console.log(el);
                    
    //                 el.addEventListener('click', (e) => {
    //                     e.preventDefault();
    //                     let that = e.currentTarget;
    //                     let parent = that.closest(".product-card");
    //                     console.log(parent);

    //                     parent.querySelectorAll(".color-item")?.forEach(innerEle => {
    //                         innerEle.classList.remove('active');
    //                     });
    //                     that.classList.add("active");
    //                     parent.querySelector('.product-card-product-heading').innerHTML = that.getAttribute('data-title');
    //                     let mainImage = that.getAttribute('data-main-image');
    //                     let hoverImage = that.getAttribute('data-hover-image');
    //                     let imageEle = parent.querySelector('.product-card-image .aspect-natural');
    //                     imageEle.querySelector(".Image__Loader").classList.add("active");
    //                     let mainImageTag = new Image();
    //                     console.log(mainImage,hoverImage);
    //                     mainImageTag.onload = () => {
    //                         imageEle.querySelector(".product-card-img").remove();
    //                         imageEle.querySelector(".mainImage").appendChild(mainImageTag);
    //                         imageEle.querySelector(".Image__Loader").classList.remove("active");
    //                     }
    //                     mainImageTag.setAttribute("src", mainImage);
    //                     mainImageTag.setAttribute("class", "product-item-image blur-up img-fluid relative product-card-img lazyautosizes lazyloaded");

    //                     let hoverImageTag = new Image();
    //                     hoverImageTag.onload = () => {
    //                         imageEle.querySelector('.hoverImage .group-hover-image').remove();
    //                         imageEle.querySelector(".hoverImage").appendChild(hoverImageTag);
    //                         imageEle.querySelector(".Image__Loader").classList.remove("active");
    //                     }
    //                     hoverImageTag.setAttribute("src", hoverImage);
    //                     hoverImageTag.setAttribute("is", "responsive-image");
    //                     hoverImageTag.setAttribute("class", "relative group-hover-image");
    //                 });
    //             });
    //             qsa('.dots-item')?.forEach(el => {
    //                 el.addEventListener('click', (e) => {
    //                     let colorList = el.closest('.color-list');
    //                     el.remove();
    //                     qsa('.color-item.hidden', colorList)?.forEach(rmEl => {
    //                         rmEl.classList.remove('hidden');
    //                     })
    //                 })
    //             })
    //         }, 500);


    //         // Add event listeners for size swatch toggle functionality
    //         qsa('.add-item-btn-js')?.forEach(el => {
    //             el.addEventListener('click', (e) => {
    //                 e.preventDefault();
    //                 let that = e.currentTarget;
    //                 let productCard = that.closest('.product-card');

    //                 console.log('Add item button clicked', productCard);

    //                 if (productCard) {
    //                     let sizeWrapper = qs('.size-swatch-wrapper', productCard);
    //                     console.log('Size wrapper found:', sizeWrapper);
    //                     if (sizeWrapper) {
    //                         // Remove active class from all other size wrappers
    //                         qsa('.size-swatch-wrapper.active')?.forEach(wrapper => {
    //                             wrapper.classList.remove('active');
    //                         });

    //                         // Add active class to current size wrapper
    //                         sizeWrapper.classList.add('active');
    //                         console.log('Size wrapper activated');

    //                         // Check if size items exist
    //                         let sizeItems = qsa('.size-item', sizeWrapper);
    //                         console.log('Size items found:', sizeItems.length);
    //                     } else {
    //                         console.log('No size wrapper found in product card');
    //                     }
    //                 } else {
    //                     console.log('No product card found');
    //                 }
    //             });
    //         });

    //         // Add event listeners for size swatch close functionality
    //         qsa('.size-swatch-close')?.forEach(el => {
    //             el.addEventListener('click', (e) => {
    //                 e.preventDefault();
    //                 let that = e.currentTarget;
    //                 let sizeWrapper = that.closest('.size-swatch-wrapper');

    //                 if (sizeWrapper) {
    //                     sizeWrapper.classList.remove('active');
    //                 }
    //             });
    //         });


    //         // Function to attach event listeners
    //         function attachSizeSwatchListeners() {
    //             // Add event listeners for size swatch toggle functionality
    //             qsa('.add-item-btn-js')?.forEach(el => {
    //                 // Check if listener already attached
    //                 if (!el.hasAttribute('data-size-swatch-listener')) {
    //                     el.setAttribute('data-size-swatch-listener', 'true');
    //                     el.addEventListener('click', (e) => {
    //                         e.preventDefault();
    //                         let that = e.currentTarget;
    //                         let productCard = that.closest('.product-card');

    //                         if (productCard) {
    //                             let sizeWrapper = qs('.size-swatch-wrapper', productCard);
    //                             if (sizeWrapper) {
    //                                 // Remove active class from all other size wrappers
    //                                 qsa('.size-swatch-wrapper.active')?.forEach(wrapper => {
    //                                     wrapper.classList.remove('active');
    //                                 });

    //                                 // Add active class to current size wrapper
    //                                 sizeWrapper.classList.add('active');
    //                             }
    //                         }
    //                     });
    //                 }
    //             });

    //             // Add event listeners for size swatch close functionality
    //             qsa('.size-swatch-close')?.forEach(el => {
    //                 // Check if listener already attached
    //                 if (!el.hasAttribute('data-size-swatch-close-listener')) {
    //                     el.setAttribute('data-size-swatch-close-listener', 'true');
    //                     el.addEventListener('click', (e) => {
    //                         e.preventDefault();
    //                         let that = e.currentTarget;
    //                         let sizeWrapper = that.closest('.size-swatch-wrapper');

    //                         if (sizeWrapper) {
    //                             sizeWrapper.classList.remove('active');
    //                         }
    //                     });
    //                 }
    //             });
    //         }

    //         // Initial attachment
    //         attachSizeSwatchListeners();

    //         // Set up mutation observer to handle dynamically added elements
    //         const observer = new MutationObserver((mutations) => {
    //             let shouldReattach = false;
    //             mutations.forEach((mutation) => {
    //                 if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
    //                     mutation.addedNodes.forEach((node) => {
    //                         if (node.nodeType === 1) { // Element node
    //                             if (node.classList?.contains('add-item-btn-js') ||
    //                                 node.classList?.contains('size-swatch-close') ||
    //                                 node.querySelector?.('.add-item-btn-js') ||
    //                                 node.querySelector?.('.size-swatch-close')) {
    //                                 shouldReattach = true;
    //                             }
    //                         }
    //                     });
    //                 }
    //             });

    //             if (shouldReattach) {
    //                 setTimeout(attachSizeSwatchListeners, 100);
    //             }
    //         });

    //         // Start observing
    //         observer.observe(document.body, {
    //             childList: true,
    //             subtree: true
    //         });


    //         return data;
    //     }
    // ); by wizzy
}

// Add to cart function
async function addToCart(variantId, quantity = 1) {

    try {
        // Show loading state
        const loadingEvent = new CustomEvent('ARMADA:CART:LOADING', { detail: { loading: true } });
        document.dispatchEvent(loadingEvent);

        // Use the existing cart engine if available
        if (window.eight && window.eight.cartEngine && window.eight.cartEngine.addToCart) {
            await window.eight.cartEngine.addToCart(variantId, quantity);

            // Wait a bit for cart to update
            await new Promise(resolve => setTimeout(resolve, 500));

            // Hide loading state
            const loadingEventEnd = new CustomEvent('ARMADA:CART:LOADING', { detail: { loading: false } });
            document.dispatchEvent(loadingEventEnd);

            // Open cart drawer after cart is updated
            openCartDrawer();
        } else {
            // Fallback to direct API call
            const formData = {
                'items': [{
                    'id': variantId,
                    'quantity': quantity
                }]
            };

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                const result = await response.json();

                // Trigger cart update event
                const cartUpdateEvent = new CustomEvent('ARMADA:CART:UPDATE', { detail: result });
                document.dispatchEvent(cartUpdateEvent);

                // Wait for cart to update
                await new Promise(resolve => setTimeout(resolve, 300));

                // Hide loading state
                const loadingEventEnd = new CustomEvent('ARMADA:CART:LOADING', { detail: { loading: false } });
                document.dispatchEvent(loadingEventEnd);

                // Open cart drawer
                openCartDrawer();
            } else {
                const errorText = await response.text();
                // Hide loading state on error
                const loadingEventEnd = new CustomEvent('ARMADA:CART:LOADING', { detail: { loading: false } });
                document.dispatchEvent(loadingEventEnd);
            }
        }
    } catch (error) {
        // Hide loading state on error
        const loadingEventEnd = new CustomEvent('ARMADA:CART:LOADING', { detail: { loading: false } });
        document.dispatchEvent(loadingEventEnd);
    }
}

function openCartDrawer() {
    // Wait a bit more to ensure cart is fully updated
    setTimeout(() => {
        // Try to open the cart drawer using the theme's existing functionality
        if (window.sideCart) {
            window.sideCart.toggleSideCart();
        } else if (window.eight && window.eight.cartEngine) {
            // Trigger cart update event
            document.dispatchEvent(new CustomEvent('ARMADA:CART:ADD'));

            // Also try to trigger cart refresh
            if (window.eight.cartEngine.refreshCart) {
                window.eight.cartEngine.refreshCart();
            }
        } else {
            // Fallback: try to find and click cart button
            const cartButton = document.querySelector('.header-cart-js, .cart-button, [data-cart-toggle]');
            if (cartButton) {
                cartButton.click();
            }
        }

        // Additional fallback: trigger cart update events
        document.dispatchEvent(new CustomEvent('ARMADA:CART:UPDATE'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
    }, 200);
}



function findHaxCode(key) {

    if (colorMap.has(key)) {
        return colorMap.get(key);
    } else {
        return [key, false];
    }
}


window.replaceWizzyTemplate = (ele) => {
    let newDiv = document.getElementById(ele + "-new");
    let oldDiv = document.getElementById(ele);
    newDiv = newDiv.text;
    oldDiv.text = newDiv;
};


